export const ls = {
  ls_common_top_menu_login: {
    uk: `Вхід в систему`,
    ru: `Вход в систему`,
    eng: `Log in`,
  },
  ls_common_top_menu_signup: {
    uk: `Реєстрація`,
    ru: `Регистрация`,
    eng: `Sign up`,
  },
  ls_common_top_menu_demo: {
    uk: `Демо версія`,
    ru: `Демо версия`,
    eng: `Demo version`,
  },
  ls_start_screen_login_form_title: {
    uk: `Вхід в систему Інтернет-банкінгу`,
    ru: `Вход в систему Интернет-банкинга`,
    eng: `Log in to Internet banking`,
  },
  ls_start_screen_login_field_label: {
    uk: `Логін`,
    ru: `Логин`,
    eng: `Login`,
  },
  ls_start_screen_password_field_label: {
    uk: `Пароль`,
    ru: `Пароль`,
    eng: `Password`,
  },
  ls_start_screen_login_field_placeholder: {
    uk: `+380`,
    ru: `+380`,
    eng: `+380`,
  },
  ls_start_screen_password_field_placeholder: {
    uk: `Введіть пароль`,
    ru: `Введите пароль`,
    eng: `Enter password`,
  },
  ls_start_screen_forgot_password_link: {
    uk: `Забули пароль?`,
    ru: `Забыли пароль? `,
    eng: `Forgot password?`,
  },
  ls_start_screen_login_button_normal: {
    uk: `Увійти`,
    ru: `Войти`,
    eng: `Log in`,
  },
  ls_start_screen_get_mobile_message: {
    uk: `Завантажте мобільну версію Інтернет-банкінгу`,
    ru: `Загрузите мобильную версию Интернет-банкинга`,
    eng: `Download mobile banking application`,
  },
  ls_start_screen_login_button_loading: {
    uk: `В обробці`,
    ru: `В обработке`,
    eng: `Processing`,
  },
  ls_start_screen_language_selector_en: {
    uk: `English`,
    ru: `English`,
    eng: `English`,
  },
  ls_start_screen_language_selector_ru: {
    uk: `Русский`,
    ru: `Русский`,
    eng: `Русский`,
  },
  ls_start_screen_language_selector_uk: {
    uk: `Українська`,
    ru: `Українська`,
    eng: `Українська`,
  },
  ls_common_language_switcher_en: {
    uk: `EN`,
    ru: `EN`,
    eng: `EN`,
  },
  ls_common_language_switcher_ru: {
    uk: `RU`,
    ru: `RU`,
    eng: `RU`,
  },
  ls_common_language_switcher_uk: {
    uk: `UA`,
    ru: `UA`,
    eng: `UA`,
  },
  ls_reset_password_dialog_title: {
    uk: `Забули пароль? `,
    ru: `Забыли пароль? `,
    eng: `Forgot your password?`,
  },
  ls_reset_password_dialog_message: {
    uk: `Натисніть кнопку СКИНУТИ для відновлення доступу до облікового запису.`,
    ru: `Нажмите кнопку СБРОСИТЬ для восстановления доступа к учетной записи.`,
    eng: `Press RESET to renew access to the account.`,
  },
  ls_common_dialog_reset_button: {
    uk: `Скинути`,
    ru: `Сбросить`,
    eng: `Reset`,
  },
  ls_common_close_button_normal: {
    uk: `Закрити`,
    ru: `Закрыть`,
    eng: `Close`,
  },
  ls_initial_password_entered_message: {
    uk: `Ви ввели одноразовий пароль. Будь ласка, оберіть постійний пароль для входу в систему.`,
    ru: `Вы ввели одноразовый пароль. Пожалуйста, выберите постоянный пароль для входа в систему.`,
    eng: `You have entered a one time password. Please, choose a permanent password for signing in to the system.`,
  },
  ls_set_password_new_password_field_title: {
    uk: `Новий пароль`,
    ru: `Новый пароль`,
    eng: `New password`,
  },
  ls_set_password_new_password_field_placeholder: {
    uk: `Введіть новий пароль`,
    ru: `Введите новый пароль`,
    eng: `Enter new password`,
  },
  ls_set_password_repeat_password_field_title: {
    uk: `Підтвердити пароль`,
    ru: `Подтвердить пароль`,
    eng: `Confirm password`,
  },
  ls_set_password_repeat_password_field_placeholder: {
    uk: `Повторіть пароль`,
    ru: `Повторите пароль`,
    eng: `Repeat password`,
  },
  ls_set_password_message: {
    uk: `Довжина паролю від <span>8 знаків</span> латиницею. Пароль має містити хоча б <span>одну велику літеру</span> та <span>дві цифри</span>.`,
    ru: `Длина пароля от <span>8 знаков</span> латиницей. Пароль должен содержать хотя бы <span>одну заглавную букву</span> и <span>две цифры</span>.`,
    eng: `Password length from <span>8 latin symbols</span>. Must contain at least <span>one capital letter</span> and <span>two digits</span>.`,
  },
  ls_set_password_no_match_error_message: {
    uk: `Паролі не співпадають`,
    ru: `Пароли не совпадают`,
    eng: `Passwords do not match`,
  },
  ls_set_password_wrong_format_error_message: {
    uk: `Пароль не відповідає вимогам`,
    ru: `Пароль не соответствует требованиям`,
    eng: `Password doesn't meet requirements`,
  },
  ls_set_password_confirm_button_normal: {
    uk: `Зберегти та продовжити`,
    ru: `Сохранить и продолжить`,
    eng: `Save and continue`,
  },
  ls_set_password_confirm_button_loading: {
    uk: `В обробці`,
    ru: `В обработке`,
    eng: `Processing`,
  },
  ls_login_bad_credentials_error_message: {
    uk: `Невірний логін або пароль. Будь ласка, перевірте дані та спробуйте ще раз.`,
    ru: `Неверный логин или пароль. Пожалуйста, проверьте данные и попробуйте еще раз.`,
    eng: `Incorrect login or password. Check your entries and try again.`,
  },
  ls_maintenance_error_title: {
    uk: `В системі йдуть технічні роботи`,
    ru: `В системе идут технические работы`,
    eng: `System is under maintenance`,
  },
  ls_maintenance_error_message: {
    uk: `Спробуйте увійти до системи через деякий час.`,
    ru: `Попробуйте войти в систему через некоторое время.`,
    eng: `Try signing in to the system later.`,
  },
  ls_common_support_phone_number: {
    uk: `0532 610 002`,
    ru: `0532 610 002`,
    eng: `0532 610 002`,
  },
  ls_common_return_to_signin_link: {
    uk: `Повернутись на сторінку входу до системи`,
    ru: `Вернуться на страницу входа в систему`,
    eng: `Return to sign in page`,
  },
  ls_login_bad_account_blocked_error_title: {
    uk: `Доступ до системи заблоковано`,
    ru: `Доступ к системе заблокирован`,
    eng: `System is locked`,
  },
  ls_login_bad_account_blocked_error_message: {
    uk: `Доступ заблоковано з метою безпеки. Щоб розблокувати систему зверніться до Банку за телефоном:`,
    ru: `Доступ заблокирован в целях безопасности. Чтобы разблокировать систему обратитесь в Банк по телефону:`,
    eng: `The system is locked for security reasons. To unlock the system, please contact the Bank on phone number:`,
  },
  ls_login_account_temporarily_blocked_error_title: {
    uk: `Доступ до системи заблоковано`,
    ru: `Доступ к системе заблокирован`,
    eng: `System is locked`,
  },
  ls_login_account_temporarily_blocked_error_message: {
    uk: `Систему заблоковано в цілях безпеки. Спробуйте увійти до системи ще раз через 30 хвилин.`,
    ru: `Система заблокирована в целях безопасности. Попробуйте войти через 30 минут.`,
    eng: `The system is locked for security reasons. Try signing in in 30 minutes.`,
  },
  ls_initial_password_expired_error_message: {
    uk: `Строк дії введеного паролю закінчився. Зверніться до служби підтримки Банку, щоб отримати новий пароль.`,
    ru: `Срок действия введенного пароля истек. Обратитесь в службу поддержки Банка, чтобы получить новый пароль.`,
    eng: `Password expired. Contact Bank support to obtain a new password.`,
  },
  ls_old_browser_error_title: {
    uk: `Схоже ви використовуєте застарілу версію веб-браузеру`,
    ru: `Похоже вы используете устаревшую версию веб-браузера`,
    eng: `Seems that you're using an outdated browser version`,
  },
  ls_old_browser_error_message: {
    uk: `Для коректної роботи в системі Інтернет-банкінгу, будь ласка, скористайтесь одним з наступних веб-браузерів.`,
    ru: `Для корректной работы в системе Интернет-банкинга, пожалуйста, воспользуйтесь одним из следующих веб-браузеров.`,
    eng: `For system to work correctly, please, use one of the following web browsers.`,
  },
  ls_old_browser_name_edge: {
    uk: `Edge`,
    ru: `Edge`,
    eng: `Edge`,
  },
  ls_old_browser_name_chrome: {
    uk: `Chrome`,
    ru: `Chrome`,
    eng: `Chrome`,
  },
  ls_old_browser_name_firefox: {
    uk: `Firefox`,
    ru: `Firefox`,
    eng: `Firefox`,
  },
  ls_old_browser_name_safari: {
    uk: `Safari`,
    ru: `Safari`,
    eng: `Safari`,
  },
  ls_old_browser_name_opera: {
    uk: `Opera`,
    ru: `Opera`,
    eng: `Opera`,
  },
  ls_common_request_failed_error_message: {
    uk: `Не вдалося виконати запит. Спробуйте ще раз через деякий час. `,
    ru: `Не удалось выполнить запрос. Попробуйте еще раз через некоторое время.`,
    eng: `Failed to complete request. Please try again later.`,
  },
  ls_change_password_button_label: {
    uk: `Змінити пароль`,
    ru: `Сменить пароль`,
    eng: `Change password`,
  },
  ls_change_static_password_screen_title: {
    uk: `Змінити пароль входу до системи`,
    ru: `Сменить пароль входа в систему`,
    eng: `Change login password`,
  },
  ls_change_password_current_password_field_title: {
    uk: `Поточний пароль`,
    ru: `Текущий пароль`,
    eng: `Current password`,
  },
  ls_change_password_current_password_field_placeholder: {
    uk: `Введіть поточний пароль`,
    ru: `Введите текущий пароль`,
    eng: `Enter current password`,
  },
  ls_change_password_success_title: {
    uk: `Пароль успішно змінений!`,
    ru: `Пароль успешно изменен!`,
    eng: `Password changed!`,
  },
  ls_change_password_success_message: {
    uk: `При наступному вході в систему використовуйте новий пароль.`,
    ru: `При следующем входе в систему используйте новый пароль.`,
    eng: `Next time use the new password to sign in to the system.`,
  },
  ls_change_password_current_password_error: {
    uk: `Невірний пароль`,
    ru: `Неверный пароль`,
    eng: `Incorrect password`,
  },
  ls_change_password_must_be_different_error: {
    uk: `Пароль має відрізнятись від поточного`,
    ru: `Пароль должен отличаться от текущего`,
    eng: `Password should not match current one`,
  },
  ls_change_static_confirm_button_normal: {
    uk: `Змінити пароль`,
    ru: `Сменить пароль`,
    eng: `Change password`,
  },
  ls_edit_profile_button_label: {
    uk: `Редагувати`,
    ru: `Редактировать`,
    eng: `Edit profile`,
  },
  ls_profile_screen_title: {
    uk: `Профіль`,
    ru: `Профиль`,
    eng: `Profile`,
  },
  ls_profile_full_name_field_label: {
    uk: `Прізвище, ім'я та по-батькові`,
    ru: `Фамилия, имя и отчество`,
    eng: `Enter your full name`,
  },
  ls_profile_contact_phone_field_label: {
    uk: `Контактний телефон`,
    ru: `Контактный телефон`,
    eng: `Contact phone number`,
  },
  ls_profile_address_field_label: {
    uk: `Адреса`,
    ru: `Адрес`,
    eng: `Address`,
  },
  ls_profile_email_field_label: {
    uk: `Електронна пошта`,
    ru: `Электронная почта`,
    eng: `Email`,
  },
  ls_profile_email_field_placeholder: {
    uk: `Введіть адресу електронної пошти`,
    ru: `Введите адрес электронной почты`,
    eng: `Enter email address`,
  },
  ls_common_save_button_label: {
    uk: `Зберегти`,
    ru: `Сохранить`,
    eng: `Save`,
  },
  ls_common_operation_successful_message: {
    uk: `Операцію успішно виконано!`,
    ru: `Операция успешно выполнена!`,
    eng: `Operation successful!`,
  },
  ls_profile_email_field_error: {
    uk: `Має бути формату name@host.com`,
    ru: `Должно иметь формат name@host.com`,
    eng: `Should have format name@host.com`,
  },
  ls_about_app_menu_item_text: {
    uk: `Про застосунок`,
    ru: `О приложении`,
    eng: `About application`,
  },
  ls_about_application_name_label: {
    uk: `Назва: `,
    ru: `Название: `,
    eng: `Name: `,
  },
  ls_about_application_name: {
    uk: `Poltava-bank Online Banking`,
    ru: `Poltava-bank Online Banking`,
    eng: `Poltava-bank Online Banking`,
  },
  ls_about_application_version_label: {
    uk: `Версія: `,
    ru: `Версия: `,
    eng: `Version: `,
  },
  ls_about_application_publisher_label: {
    uk: `Видавник: `,
    ru: `Издатель: `,
    eng: `Publisher: `,
  },
  ls_about_application_publisher_name: {
    uk: `АТ “Полтава-Банк“`,
    ru: `АО “Полтава-Банк“`,
    eng: `JSC “Poltava-bank”`,
  },
  ls_about_application_developer_label: {
    uk: `Розробник: `,
    ru: `Разработчик: `,
    eng: `Developer: `,
  },
  ls_about_application_developer_name: {
    uk: `Kapowai`,
    ru: `Kapowai`,
    eng: `Kapowai`,
  },
  ls_about_application_license_label: {
    uk: `Ліцензія: `,
    ru: `Лицензия: `,
    eng: `License: `,
  },
  ls_about_application_license_text: {
    uk: `Ліцензія НБУ №56 від 28.10.2011`,
    ru: `Лицензия НБУ №56 от 28.10.2011`,
    eng: `NBU license #56 dd. 28.10.2011`,
  },
  ls_overview_tab_label: {
    uk: `Огляд`,
    ru: `Обзор`,
    eng: `Overview`,
  },
  ls_cards_and_accounts_tab_label: {
    uk: `Картки та рахунки`,
    ru: `Карты и счета`,
    eng: `Cards & Accounts`,
  },
  ls_payments_tab_label: {
    uk: `Платежі`,
    ru: `Платежи`,
    eng: `Payments`,
  },
  ls_deposits_tab_label: {
    uk: `Депозити`,
    ru: `Депозиты`,
    eng: `Deposits`,
  },
  ls_credits_tab_label: {
    uk: `Кредити`,
    ru: `Кредиты`,
    eng: `Credits`,
  },
  ls_tune_widgets_link_text: {
    uk: `Налаштувати віджети`,
    ru: `Настроить виджеты`,
    eng: `Tune widgets`,
  },
  ls_last_login_message_text: {
    uk: `Останній вхід: `,
    ru: `Последний вход: `,
    eng: `Latest login: `,
  },
  ls_bank_currency_rates_widget_title: {
    uk: `Курси банку`,
    ru: `Курсы банка`,
    eng: `Bank rates`,
  },
  ls_card_currency_rates_widget_title: {
    uk: `Для карток`,
    ru: `Для карт`,
    eng: `Card rates`,
  },
  ls_currency_converter_widget_title: {
    uk: `Конвертер`,
    ru: `Конвертер`,
    eng: `Converter`,
  },
  ls_currency_widget_currency_label: {
    uk: `Валюта`,
    ru: `Валюта`,
    eng: `Currency`,
  },
  ls_currency_widget_buy_label: {
    uk: `Купівля`,
    ru: `Покупка`,
    eng: `Buy`,
  },
  ls_currency_widget_sell_label: {
    uk: `Продаж`,
    ru: `Продажа`,
    eng: `Sell`,
  },
  ls_currency_widget_nbu_rate_label: {
    uk: `Курс НБУ`,
    ru: `Курс НБУ`,
    eng: `NBU rate`,
  },
  ls_currency_widget_currency_rates_on: {
    uk: `На`,
    ru: `На`,
    eng: `As of`,
  },
  ls_currency_widget_GBP: {
    uk: `GBP`,
    ru: `GBP`,
    eng: `GBP`,
  },
  ls_currency_widget_USD: {
    uk: `USD`,
    ru: `USD`,
    eng: `USD`,
  },
  ls_currency_widget_EUR: {
    uk: `EUR`,
    ru: `EUR`,
    eng: `EUR`,
  },
  ls_currency_widget_RUB: {
    uk: `RUB`,
    ru: `RUB`,
    eng: `RUB`,
  },
  ls_currency_widget_CHF: {
    uk: `CHF`,
    ru: `CHF`,
    eng: `CHF`,
  },
  ls_currency_widget_PLN: {
    uk: `PLN`,
    ru: `PLN`,
    eng: `PLN`,
  },
  ls_currency_widget_CZK: {
    uk: `CZK`,
    ru: `CZK`,
    eng: `CZK`,
  },
  ls_currency_widget_notice: {
    uk: `Операції по картковим рахункам у валютах, відмінних від USD конвертуються згідно з курсами MasterCard.`,
    ru: `Операции по карточным счетам отличным от USD конвертируются согласно курсов MasterCard.`,
    eng: `Operations on accounts with currency different from USD are converted in accordance to MasterCard currency rates.`,
  },
  ls_converter_sell_rate_notice: {
    uk: `При розрахунку використовується поточний курс продажу банком для обраної валюти.`,
    ru: `При расчете используется текущий курс продажи банком для выбранной валюты.`,
    eng: `Current bank sell rate for selected currency is used for calculation.`,
  },
  ls_converter_buy_rate_notice: {
    uk: `При розрахунку використовується поточний курс покупки банком для обраної валюти.`,
    ru: `При расчете используется текущий курс покупки банком для выбранной валюты.`,
    eng: `Current bank buy rate for selected currency is used for calculation.`,
  },
  ls_converter_choose_different_currencies_notice: {
    uk: `Оберіть різні валюти, для яких необхідно виконати розрахунок.`,
    ru: `Выберите разные валюты, для которых необходимо выполнить расчет.`,
    eng: `Select different currencies for which you want perform the calculation.`,
  },
  ls_converter_cross_conversion_notice: {
    uk: `Розрахунок виконується як продаж початкової валюти з наступною покупкою валюти конверсії за виручену гривню. Результат не включає в себе податки і збори.`,
    ru: `Расчет производится как продажа исходной валюты с последующей покупкой валюты конверсии за вырученную гривну. Результат не включает в себя налоги и сборы.`,
    eng: `The calculation is performed as a sale of the original currency for UAH, followed by the purchase of the conversion currency with received UAH. The result does not include taxes and fees.`,
  },
  ls_currency_widget_GBP_full_name: {
    uk: `Фунт стерлінгів`,
    ru: `Фунт стерлингов	`,
    eng: `Pound sterling `,
  },
  ls_currency_widget_USD_full_name: {
    uk: `Долар США`,
    ru: `Доллар США`,
    eng: `US Dollar`,
  },
  ls_currency_widget_EUR_full_name: {
    uk: `Євро (Європейський Союз)`,
    ru: `Евро (Европейский Союз)`,
    eng: `Euro (European Union)`,
  },
  ls_currency_widget_RUB_full_name: {
    uk: `Російський рубль`,
    ru: `Российский рубль`,
    eng: `Russian ruble`,
  },
  ls_currency_widget_CHF_full_name: {
    uk: `Швейцарський франк`,
    ru: `Швейцарский франк`,
    eng: `Switzerland franc`,
  },
  ls_currency_widget_PLN_full_name: {
    uk: `Польский злотий`,
    ru: `Польский злотый`,
    eng: `Polish złoty`,
  },
  ls_currency_widget_CZK_full_name: {
    uk: `Чеська крона`,
    ru: `Чешская крона`,
    eng: `Czech koruna`,
  },
  ls_currency_widget_UAH_full_name: {
    uk: `Українська гривня`,
    ru: `Украинская гривна`,
    eng: `Ukrainian hryvnia`,
  },
  ls_common_widget_view_all_button: {
    uk: `Показати всі`,
    ru: `Показать все`,
    eng: `View all`,
  },
  ls_cards_accounts_screen_empty_message_title: {
    uk: `У вас ще немає карток та рахунків`,
    ru: `У вас еще нет карт и счетов`,
    eng: `You do not have card or account yet`,
  },
  ls_cards_accounts_screen_empty_message_text: {
    uk: `Замовте платіжну карту зараз, щоб скористатися послугами банку в повному обсязі.`,
    ru: `Замовте платіжну карту зараз, щоб скористатися послугами банку в повному обсязі.`,
    eng: `Замовте платіжну карту зараз, щоб скористатися послугами банку в повному обсязі.`,
  },
  ls_common_order_card_button_normal: {
    uk: `Замовити картку`,
    ru: `Заказать карту`,
    eng: `Order card`,
  },
  ls_cards_widget_title: {
    uk: `Картки`,
    ru: `Карты`,
    eng: `Cards`,
  },
  ls_accounts_widget_title: {
    uk: `Рахунки`,
    ru: `Счета`,
    eng: `Accounts`,
  },
  ls_common_details_widget_title: {
    uk: `Детальна інформація`,
    ru: `Подробная информация`,
    eng: `Details`,
  },
  ls_operations_widget_title: {
    uk: `Останні операції`,
    ru: `Последние операции`,
    eng: `Recent operations`,
  },
  ls_holds_widget_title: {
    uk: `Блокування`,
    ru: `Блокировки`,
    eng: `Holds`,
  },
  ls_operations_widget_empty_message_text: {
    uk: `Ви ще не здійснювали операцій.`,
    ru: `Вы еще не осуществляли операций.`,
    eng: `You have not made any operations.`,
  },
  ls_card_list_item_debt_label: {
    uk: `Борг: `,
    ru: `Долг: `,
    eng: `Debt: `,
  },
  ls_card_details_type_label: {
    uk: `Тип: `,
    ru: `Тип: `,
    eng: `Type: `,
  },
  ls_card_details_valid_through_label: {
    uk: `Дійсна до: `,
    ru: `Действительна до: `,
    eng: `Valid through: `,
  },
  ls_card_details_status_label: {
    uk: `Статус: `,
    ru: `Статус: `,
    eng: `Status: `,
  },
  ls_card_details_owner_label: {
    uk: `Власник картки: `,
    ru: `Владелец карты: `,
    eng: `Card owner: `,
  },
  ls_card_tariff_label: {
    uk: `Тариф: `,
    ru: `Тариф: `,
    eng: `Tariff: `,
  },
  ls_card_details_status_active_text: {
    uk: `Активна`,
    ru: `Активна`,
    eng: `Active`,
  },
  ls_card_details_status_inactive_text: {
    uk: `Неактивна`,
    ru: `Неактивна`,
    eng: `Inactive`,
  },
  ls_card_details_status_blocked_text: {
    uk: `Заблокована`,
    ru: `Заблокирована`,
    eng: `Blocked`,
  },
  ls_card_details_status_expired_text: {
    uk: `Прострочена`,
    ru: `Просрочена`,
    eng: `Expired`,
  },
  ls_card_details_account_label: {
    uk: `Рахунок: `,
    ru: `Счет: `,
    eng: `Account: `,
  },
  ls_card_details_account_requisites_label: {
    uk: `Реквізити рахунку`,
    ru: `Реквизиты счета`,
    eng: `Account requisites`,
  },
  ls_account_details_balance_label: {
    uk: `Баланс: `,
    ru: `Баланс: `,
    eng: `Balance: `,
  },
  ls_account_details_own_funds_label: {
    uk: `Власні кошти: `,
    ru: `Личные средства: `,
    eng: `Own funds: `,
  },
  ls_account_details_credit_limit_label: {
    uk: `Кредитний ліміт: `,
    ru: `Кредитный лимит: `,
    eng: `Credit limit: `,
  },
  ls_account_details_used_credit_label: {
    uk: `Використано кредиту: `,
    ru: `Использовано кредита: `,
    eng: `Used credit: `,
  },
  ls_account_refill_account_button_label: {
    uk: `Поповнити рахунок`,
    ru: `Пополнить счет`,
    eng: `Refill account`,
  },
  ls_otp_confirmation_direct_transfer_title: {
    uk: `Відправити платіж`,
    ru: `Отправить платеж`,
    eng: `Send payment`,
  },
  ls_common_widget_load_more_button: {
    uk: `Завантажити ще`,
    ru: `Загрузить еще`,
    eng: `Load more`,
  },
  ls_common_section_today_label: {
    uk: `Сьогодні`,
    ru: `Сегодня`,
    eng: `Today`,
  },
  ls_common_section_yesterday_label: {
    uk: `Вчора`,
    ru: `Вчера`,
    eng: `Yesterday`,
  },
  ls_operation_status_received_text: {
    uk: `Отримано`,
    ru: `Получено`,
    eng: `Received`,
  },
  ls_operation_status_processing_text: {
    uk: `В обробці`,
    ru: `В обработке`,
    eng: `Processing`,
  },
  ls_operation_status_rejected_text: {
    uk: `Відхилено`,
    ru: `Отклонено`,
    eng: `Rejected`,
  },
  ls_operation_status_revoked_text: {
    uk: `Скасовано`,
    ru: `Отменено`,
    eng: `Canceled`,
  },
  ls_operation_status_completed_text: {
    uk: `Виконано`,
    ru: `Проведено`,
    eng: `Completed`,
  },
  ls_account_details_payment_card_label: {
    uk: `Платіжні картки: `,
    ru: `Платежные карты: `,
    eng: `Payment cards`,
  },
  ls_account_details_account_number_label: {
    uk: `Номер: `,
    ru: `Номер: `,
    eng: `Number: `,
  },
  ls_common_failed_to_load_data_error: {
    uk: `Не вдалось завантажити дані.`,
    ru: `Не удалось загрузить данные. `,
    eng: `Failed to load data.`,
  },
  ls_common_failed_to_load_data_error_message: {
    uk: `Будь ласка, спробуйте ще раз через деякий час.`,
    ru: `Попробуйте еще раз через некоторое время.`,
    eng: `Please try again after a while.`,
  },
  ls_common_try_again_button_normal: {
    uk: `Спробувати ще раз`,
    ru: `Попробовать еще раз`,
    eng: `Try again`,
  },
  ls_account_rename_dialog_title: {
    uk: `Змінити назву`,
    ru: `Сменить название`,
    eng: `Change name`,
  },
  ls_account_rename_name_field_label: {
    uk: `Назва рахунку`,
    ru: `Название счета`,
    eng: `Account name`,
  },
  ls_common_dialog_cancel_button: {
    uk: `Відміна`,
    ru: `Отмена`,
    eng: `Cancel`,
  },
  ls_common_dialog_save_button: {
    uk: `Зберегти`,
    ru: `Сохранить`,
    eng: `Save`,
  },
  ls_card_account_requisites_screen_title: {
    uk: `Реквізити для поповнення карткового рахунку`,
    ru: `Реквизиты для пополнения карточного счета`,
    eng: `Requisites to refill card account`,
  },
  ls_account_requisites_screen_title: {
    uk: `Реквізити рахунку`,
    ru: `Реквизиты счета`,
    eng: `Account requisites`,
  },
  ls_common_name_label: {
    uk: `ПІБ: `,
    ru: `ФИО: `,
    eng: `Name: `,
  },
  ls_common_ipn_label: {
    uk: `ІПН: `,
    ru: `ИНН: `,
    eng: `Tax ID: `,
  },
  ls_common_account_label: {
    uk: `Рахунок: `,
    ru: `Счет: `,
    eng: `Account: `,
  },
  ls_common_bank_name_label: {
    uk: `Банк: `,
    ru: `Банк: `,
    eng: `Bank: `,
  },
  ls_common_bank_code_label: {
    uk: `Код банку: `,
    ru: `Код банка: `,
    eng: `Bank code: `,
  },
  ls_account_requisites_in_pdf_button_normal: {
    uk: `Реквізити в PDF`,
    ru: `Реквизиты в PDF`,
    eng: `Requisites in PDF`,
  },
  ls_common_expired_date_label: {
    uk: `EXP `,
    ru: `EXP `,
    eng: `EXP `,
  },
  ls_pdf_requisites_account_requisites: {
    uk: `Реквізити рахунку`,
    ru: `Реквизиты счета`,
    eng: `Account requisites`,
  },
  ls_pdf_requisites_payment_purpose_label: {
    uk: `Призначення платежу:`,
    ru: `Назначение платежа:`,
    eng: `Payment note:`,
  },
  ls_pdf_requisites_payment_purpose_text: {
    uk: `Поповнення карткового рахунку. Отримувач `,
    ru: `Пополнение карточного счета. Получатель `,
    eng: `Refilling a card account. Receiver `,
  },
  ls_pdf_requisites_bank_name_text: {
    uk: `АТ “Полтава-Банк“`,
    ru: `АО “Полтава-Банк“`,
    eng: `JSC “Poltava-bank”`,
  },
  ls_pdf_requisites_bank_code_text: {
    uk: `331489`,
    ru: `331489`,
    eng: `331489`,
  },
  ls_pdf_requisites_swift_code_text: {
    uk: `POLTUA2X`,
    ru: `POLTUA2X`,
    eng: `POLTUA2X`,
  },
  ls_common_receipt_button_normal: {
    uk: `Квитанція`,
    ru: `Квитанция`,
    eng: `Receipt`,
  },
  ls_operation_details_details_block_title: {
    uk: `Деталі операції:`,
    ru: `Детали операции:`,
    eng: `Operation details:`,
  },
  ls_operation_details_amounts_block_title: {
    uk: `Сума операції:`,
    ru: `Сумма операции:`,
    eng: `Operation amount:`,
  },
  ls_operation_details_amount_transaction_currency_label: {
    uk: `В валюті операції: `,
    ru: `В валюте операции: `,
    eng: `In transaction currency: `,
  },
  ls_operation_details_amount_account_currency_label: {
    uk: `В валюті рахунку: `,
    ru: `В валюте счета: `,
    eng: `In account currency: `,
  },
  ls_operation_details_fee_label: {
    uk: `Комісія: `,
    ru: `Комиссия: `,
    eng: `Fee: `,
  },
  ls_operation_details_created_date_label: {
    uk: `Дата операції: `,
    ru: `Дата операции: `,
    eng: `Operation date: `,
  },
  ls_operation_details_completed_date_label: {
    uk: `Дата виконання: `,
    ru: `Дата проведения: `,
    eng: `Completion date: `,
  },
  ls_operation_details_card_number_label: {
    uk: `Платіжна картка: `,
    ru: `Платежная карта: `,
    eng: `Payment card: `,
  },
  ls_operation_details_receiver_block_title: {
    uk: `Отримувач:`,
    ru: `Получатель:`,
    eng: `Receiver:`,
  },
  ls_operation_details_sender_block_title: {
    uk: `Відправник:`,
    ru: `Отправитель:`,
    eng: `Sender:`,
  },
  ls_common_taxid_label: {
    uk: `ІПН/ЄДРПОУ: `,
    ru: `ИНН/ЕГРПОУ: `,
    eng: `Tax ID: `,
  },
  ls_common_account_short_label: {
    uk: `Р/р: `,
    ru: `Р/с: `,
    eng: `Acc: `,
  },
  ls_repeat_payment_button_normal: {
    uk: `Повторити платіж`,
    ru: `Повторить платеж`,
    eng: `Repeat payment`,
  },
  ls_search_operations_block_title: {
    uk: `Параметри пошуку`,
    ru: `Параметры поиска`,
    eng: `Search parameters`,
  },
  ls_search_operations_reset_button: {
    uk: `Скинути`,
    ru: `Сбросить`,
    eng: `Reset`,
  },
  ls_search_operations_search_filed_label: {
    uk: `Текст: `,
    ru: `Текст: `,
    eng: `Text:`,
  },
  ls_search_operations_search_filed_hint: {
    uk: `Назва отримувача або призначення платежу`,
    ru: `Название получателя или назначение платежа`,
    eng: `Receiver name or payment description`,
  },
  ls_saerch_operations_period_label: {
    uk: `Період: `,
    ru: `Период: `,
    eng: `Period:`,
  },
  ls_saerch_operations_amount_label: {
    uk: `Сума:`,
    ru: `Сумма:`,
    eng: `Amount:`,
  },
  ls_search_operations_period_day_label: {
    uk: `За день`,
    ru: `За день`,
    eng: `Today`,
  },
  ls_search_operations_period_week_label: {
    uk: `За тиждень`,
    ru: `За неделю`,
    eng: `Last week`,
  },
  ls_search_operations_period_month_label: {
    uk: `За місяць`,
    ru: `За месяц`,
    eng: `Last month`,
  },
  ls_search_operations_period_selected_label: {
    uk: `Обрані дати`,
    ru: `Выбранные даты`,
    eng: `Selected dates`,
  },
  ls_search_operations_search_button_normal: {
    uk: `Шукати`,
    ru: `Искать`,
    eng: `Search`,
  },
  ls_search_operations_type_all_label: {
    uk: `Всі операції`,
    ru: `Все операции`,
    eng: `All operations`,
  },
  ls_search_operations_type_incoming_label: {
    uk: `Надходження`,
    ru: `Поступления`,
    eng: `Incoming`,
  },
  ls_search_operations_type_outgoing_label: {
    uk: `Списання`,
    ru: `Списание`,
    eng: `Outgoing`,
  },
  ls_search_operations_loading_text: {
    uk: `Завантаження`,
    ru: `Загрузка`,
    eng: `Loading`,
  },
  ls_common_search_nothing_found_message: {
    uk: `Нічого не знайдено.`,
    ru: `Ничего не найдено.`,
    eng: `Nothing found.`,
  },
  ls_common_search_results_found_text: {
    uk: `Знайдено `,
    ru: `Найдено `,
    eng: `Found `,
  },
  ls_common_search_results_operations_text: {
    uk: ` операції`,
    ru: ` операции`,
    eng: ` operations`,
  },
  ls_search_operations_results_screen_title: {
    uk: `Результати пошуку`,
    ru: `Результаты поиска`,
    eng: `Search results`,
  },
  ls_sort_operations_new_first_option: {
    uk: `Спочатку нові`,
    ru: `Сначала новые`,
    eng: `New first`,
  },
  ls_sort_operations_old_first_option: {
    uk: `Спочатку старі`,
    ru: `Сначала старые`,
    eng: `Old first`,
  },
  ls_sort_operations_large_first_option: {
    uk: `Спочатку більші`,
    ru: `Сначала большие`,
    eng: `Large first`,
  },
  ls_sort_operations_small_first_option: {
    uk: `Спочатку менші`,
    ru: `Сначала меньшие`,
    eng: `Small first`,
  },
  ls_sort_operations_sorting_label: {
    uk: `Сортування: `,
    ru: `Сортировка: `,
    eng: `Sorting: `,
  },
  ls_cards_widget_half_full_message_text: {
    uk: `Для більшої зручності та гнучкості проведення операцій, ви можете`,
    ru: `Для большего удобства и гибкости проведения операций, вы `,
    eng: `For more convenience and flexibility in making payments you can`,
  },
  ls_cards_widget_half_full_url_text: {
    uk: `Замовити додаткову платіжну картку.`,
    ru: `Заказать дополнительную платежную карту.`,
    eng: `Order an additional card.`,
  },
  ls_operations_widget_half_full_message_text: {
    uk: `Для того, щоб швидко та легко провести необхідну оплату `,
    ru: `Чтобы быстро и легко совершить нужную оплату `,
    eng: `To make a necessary payment quickly and easily `,
  },
  ls_operations_widget_half_full_url_text: {
    uk: `Створіть новий платіж.`,
    ru: `Создайте новый платеж.`,
    eng: `Create a new payment.`,
  },
  ls_operations_widget_holds_empty_text: {
    uk: `В даний момент заблоковані суми по ваших рахунках відсутні.`,
    ru: `В данный момент заблокированные суммы по вашим счетам отсутствуют.`,
    eng: `Currently there are no holds on your accounts.`,
  },
  ls_common_session_is_expiring_title: {
    uk: `Сесія закінчується`,
    ru: `Сессия заканчивается`,
    eng: `Session is expiring`,
  },
  ls_common_session_is_expiring_message: {
    uk: `Ми помітили, що ви не користуєтесь додатком зараз. Сесію буде автоматично завершено за 5 хвилин. Бажаєте продовжити її?`,
    ru: `Мы заметили, что вы не пользуетесь приложением сейчас. Сессия автоматически завершится через 5 минут. Желаете продолжить ее?`,
    eng: `We have noticed, that you are not using the application currently. This session will automatically expire in 5 minutes. Would you like to continue it?`,
  },
  ls_common_continue_button_label: {
    uk: `Продовжити`,
    ru: `Продолжить`,
    eng: `Continue`,
  },
  ls_common_finish_button_label: {
    uk: `Завершити`,
    ru: `Завершить`,
    eng: `Finish`,
  },
  ls_block_card_dialog_title: {
    uk: `Заблокувати картку`,
    ru: `Заблокировать карту`,
    eng: `Lock card`,
  },
  ls_block_card_dialog_message: {
    uk: `Блокування картки зробить неможливим здійснення будь-яких операцій з карткою до моменту її розблокування.
        Бажаєте продовжити?`,
    ru: `Блокировка карты сделает невозможным совершение любых операций при помощи карты до момента ее разблокировки. Желаете продолжить?`,
    eng: `Locking the card will disable all operations with this card until it is unlocked. Would you like to proceed?`,
  },
  ls_block_card_dialog_block_button_normal: {
    uk: `Заблокувати`,
    ru: `Блокировать`,
    eng: `Lock`,
  },
  ls_unlock_card_dialog_title: {
    uk: `Розблокувати картку`,
    ru: `Разблокировать карту`,
    eng: `Unlock card`,
  },
  ls_unlock_card_dialog_message: {
    uk: `Картку буде розблоковано і всі операції з карткою будуть знову доступні. Бажаєте продовжити?`,
    ru: `Карта будет разблокирована и все операции с ее помощью будут снова доступны. Желаете продолжить?`,
    eng: `The card will be unlocked and all operations with it will be available again. Would you like to proceed?`,
  },
  ls_unlock_card_dialog_unlock_button_normal: {
    uk: `Розблокувати`,
    ru: `Разблокировать`,
    eng: `Unlock`,
  },
  ls_card_locked_dialog_title: {
    uk: `Картку заблоковано`,
    ru: `Карта заблокирована`,
    eng: `Card is blocked`,
  },
  ls_card_locked_dialog_message: {
    uk: `Вашу картку заблоковано Банком. Зверніться до Банку, щоб зняти блокування.`,
    ru: `Ваша карта заблокирована Банком. Обратитесь в Банк, чтобы снять блокировку.`,
    eng: `Your card is blocked by the Bank. Contact Bank support to unlock the card.`,
  },
  ls_card_rename_name_field_label: {
    uk: `Назва картки`,
    ru: `Название карты`,
    eng: `Card name`,
  },
  ls_messages_screen_empty_title: {
    uk: `У вас немає повідомлень`,
    ru: `У вас нет сообщений`,
    eng: `No messages yet`,
  },
  ls_messages_screen_empty_text: {
    uk: `Всі отримані повідомлення будуть з’являтись тут по мірі їх надходження.`,
    ru: `Все полученные сообщения будут появляться здесь по мере их поступления.`,
    eng: `All incoming messages will appear here as they arrive.`,
  },
  ls_messages_widget_title: {
    uk: `Повідомлення`,
    ru: `Сообщения`,
    eng: `Messages`,
  },
  ls_messages_message_text_widget_title: {
    uk: `Текст повідомлення`,
    ru: `Текст сообщения`,
    eng: `Message text`,
  },
  ls_messages_received_label: {
    uk: `Отримано: `,
    ru: `Получено: `,
    eng: `Received: `,
  },
  ls_card_settings_widget_title: {
    uk: `Налаштування картки`,
    ru: `Настройки карты`,
    eng: `Card settings`,
  },
  ls_card_settings_name_label: {
    uk: `Назва: `,
    ru: `Название: `,
    eng: `Name: `,
  },
  ls_card_settings_type_label: {
    uk: `Тип картки: `,
    ru: `Тип карты: `,
    eng: `Card type: `,
  },
  ls_card_settings_owner_label: {
    uk: `Власник: `,
    ru: `Владелец: `,
    eng: `Owner: `,
  },
  ls_card_settings_status_label: {
    uk: `Статус: `,
    ru: `Статус: `,
    eng: `Status: `,
  },
  ls_card_settings_block_card_button_normal: {
    uk: `Заблокувати`,
    ru: `Заблокировать`,
    eng: `Block card`,
  },
  ls_card_settings_unlock_card_button_normal: {
    uk: `Розблокувати`,
    ru: `Разблокировать`,
    eng: `Unlock card`,
  },
  ls_card_settings_limits_tab_label: {
    uk: `Ліміти`,
    ru: `Лимиты`,
    eng: `Limits`,
  },
  ls_card_settings_travel_abroad_tab_label: {
    uk: `Виїзд за кордон`,
    ru: `Выезд за границу`,
    eng: `Trip abroad`,
  },
  ls_card_settings_web_payment_tab_label: {
    uk: `Оплата в Інтернет`,
    ru: `Оплата в Интернет`,
    eng: `Web payments`,
  },
  ls_card_settings_travel_abroad_status_active: {
    uk: `Активний`,
    ru: `Активный`,
    eng: `Active`,
  },
  ls_card_settings_travel_abroad_status_processing: {
    uk: `В обробці`,
    ru: `В обработке`,
    eng: `Processing`,
  },
  ls_card_settings_travel_abroad_add_button_label: {
    uk: `Додати виїзд`,
    ru: `Добавить выезд`,
    eng: `Add trip`,
  },
  ls_card_settings_travel_abroad_delete_dialog_title: {
    uk: `Видалити виїзд`,
    ru: `Удалить выезд`,
    eng: `Delete trip`,
  },
  ls_card_settings_travel_abroad_delete_dialog_subtitle: {
    uk: `Бажаєте видалити цей виїзд за кордон?`,
    ru: `Желаете удалить этот выезд за границу?`,
    eng: `Do you want to delete this trip abroad?`,
  },
  ls_common_delete_button: {
    uk: `Видалити`,
    ru: `Удалить`,
    eng: `Delete`,
  },
  ls_card_settings_travel_abroad_dialog_title: {
    uk: `Виїзд за кордон`,
    ru: `Выезд за границу`,
    eng: `Trip abroad`,
  },
  ls_card_settings_travel_abroad_dialog_subtitle: {
    uk: `Оберіть період виїзду та країни, в які подорожуєте`,
    ru: `Выберите период выезда и страны, в которые путешествуете`,
    eng: `Choose trip period and countries you plan to visit`,
  },
  ls_trip_abroad_start_of_period_field_label: {
    uk: `Початок періоду`,
    ru: `Начало периода`,
    eng: `Start of period`,
  },
  ls_trip_abroad_end_of_period_field_label: {
    uk: `Кінець періоду`,
    ru: `Конец периода`,
    eng: `End of period`,
  },
  ls_trip_abroad_countries_field_label: {
    uk: `Країни виїзду`,
    ru: `Страны выезда`,
    eng: `Countries to visit`,
  },
  ls_trip_abroad_countries_field_placeholder: {
    uk: `Оберіть країни`,
    ru: `Выберите страны`,
    eng: `Choose countries`,
  },
  ls_trip_abroad_currencies_field_label: {
    uk: `Валюти для використання`,
    ru: `Валюты для использования`,
    eng: `Currencies to be used`,
  },
  ls_trip_abroad_currencies_field_placeholder: {
    uk: `Оберіть валюти`,
    ru: `Выберите валюты`,
    eng: `Choose currencies`,
  },
  ls_trip_abroad_widget_empty_message: {
    uk: `Немає активних виїздів за кордон.`,
    ru: `Нет активных выездов за границу.`,
    eng: `No active trips abroad.`,
  },
  ls_common_from_text: {
    uk: `З `,
    ru: `c `,
    eng: `from `,
  },
  ls_common_until_text: {
    uk: ` по `,
    ru: ` по `,
    eng: ` until `,
  },
  ls_card_limits_cash_limit_section_title: {
    uk: `Денне обмеження на зняття готівкових коштів з картки`,
    ru: `Дневное ограничение на снятие наличных средств с карты`,
    eng: `Daily limit for cash withdrawal`,
  },
  ls_card_limits_operations_quantity_field_title: {
    uk: `Кількість операцій`,
    ru: `Количество операций`,
    eng: `Number of operations`,
  },
  ls_card_limits_operations_amount_field_title: {
    uk: `Загальна сума операцій`,
    ru: `Общая сумма операций`,
    eng: `Total amount`,
  },
  ls_card_limits_field_error_from_text: {
    uk: `Від `,
    ru: `От `,
    eng: `From `,
  },
  ls_card_limits_field_error_to_text: {
    uk: `до `,
    ru: `до `,
    eng: `to `,
  },
  ls_card_limits_field_error_currency_text: {
    uk: `USD`,
    ru: `USD`,
    eng: `USD`,
  },
  ls_card_limits_pos_limit_section_title: {
    uk: `Денне обмеження на розрахунки карткою в торгівельних точках`,
    ru: `Дневное ограничение на расчеты картой в торговых точках`,
    eng: `Daily limit for payments in retail stores`,
  },
  ls_card_limits_save_button_normal: {
    uk: `Зберегти`,
    ru: `Сохранить`,
    eng: `Save`,
  },
  ls_card_limits_save_button_loading: {
    uk: `В обробці`,
    ru: `В обработке`,
    eng: `Processing`,
  },
  ls_common_otp_confirmation_dialog_title: {
    uk: `Підтвердити операцію`,
    ru: `Подтвердить операцию`,
    eng: `Confirm operation`,
  },
  ls_common_otp_confirmation_message: {
    uk: `Введіть код отриманий в SMS повідомленні`,
    ru: `Введите код полученный в SMS сообщении.`,
    eng: `Enter the verification code received in SMS.`,
  },
  ls_common_otp_confirmation_placeholder: {
    uk: `Введіть код`,
    ru: `Введите код`,
    eng: `Enter the code`,
  },
  ls_common_otp_confirmation_no_sms_message: {
    uk: `Не приходить SMS?`,
    ru: `Не приходит SMS?`,
    eng: `Did not receive SMS? `,
  },
  ls_common_otp_confirmation_send_sms_link: {
    uk: `Відправити ще раз.`,
    ru: `Отправить еще раз.`,
    eng: `Send again.`,
  },
  ls_common_otp_confirmation_button_normal: {
    uk: `Підтвердити`,
    ru: `Подтвердить`,
    eng: `Confirm`,
  },
  ls_common_otp_confirmation_button_loading: {
    uk: `В обробці`,
    ru: `В обработке`,
    eng: `Processing`,
  },
  ls_limits_value_field_placeholder: {
    uk: `0 (ліміт Банку за замовчуванням)`,
    ru: `0 (лимит Банка по умолчанию)`,
    eng: `0 (Bank limit by default)`,
  },
  ls_payment_between_accounts_widget_title: {
    uk: `Переказ між рахунками`,
    ru: `Перевод между счетами`,
    eng: `Transfer between accounts`,
  },
  ls_common_from_account_field_label: {
    uk: `Переказати з рахунку`,
    ru: `Перевести со счета`,
    eng: `Transfer from account`,
  },
  ls_common_to_account_field_label: {
    uk: `Переказати на рахунок`,
    ru: `Перевести на счет`,
    eng: `Transfer to account`,
  },
  ls_common_transfer_button_label: {
    uk: `Переказати`,
    ru: `Перевести`,
    eng: `Transfer`,
  },
  ls_common_pay_button_label: {
    uk: `Сплатити`,
    ru: `Оплатить`,
    eng: `Transfer`,
  },
  ls_payment_between_accounts_screen_title: {
    uk: `Переказ між рахунками`,
    ru: `Перевод между счетами`,
    eng: `Transfer between accounts`,
  },
  ls_common_payment_amount_text: {
    uk: `(Сума платежу: `,
    ru: `(Сумма платежа: `,
    eng: `(Payment amount: `,
  },
  ls_common_including_fee_text: {
    uk: ` + комісія: `,
    ru: ` + комисия: `,
    eng: ` + fee: `,
  },
  ls_common_edning_score_symbol: {
    uk: `)`,
    ru: `)`,
    eng: `)`,
  },
  ls_common_operation_sent_for_processing_message: {
    uk: `Операцію відправлено в обробку!`,
    ru: `Операция отправлена в обработку!`,
    eng: `Operation sent for processing!`,
  },
  ls_common_enter_amount_message: {
    uk: `Введіть суму для переказу`,
    ru: `Введите сумму перевода`,
    eng: `Enter transfer amount`,
  },
  ls_payment_error_insufficient_funds_title: {
    uk: `Недостатньо коштів`,
    ru: `Недостаточно средств`,
    eng: `Insufficient funds`,
  },
  ls_payment_error_insufficient_funds_message: {
    uk: `Недостатньо коштів для здійснення операції. `,
    ru: `Недостаточно средств для проведения операции. `,
    eng: `Not enough funds to make the payment. `,
  },
  ls_payment_error_insufficient_funds_amount: {
    uk: `Сума: `,
    ru: `Сумма: `,
    eng: `Amount: `,
  },
  ls_payment_error_insufficient_funds_amount_currency: {
    uk: ` UAH,`,
    ru: ` UAH,`,
    eng: ` UAH,`,
  },
  ls_payment_error_insufficient_funds_fee: {
    uk: ` + Комісія: `,
    ru: ` + Комисия: `,
    eng: ` + Fee: `,
  },
  ls_payment_error_insufficient_funds_fee_currency: {
    uk: ` UAH. `,
    ru: ` UAH. `,
    eng: ` UAH. `,
  },
  ls_common_otp_confirmation_permanent_error_title: {
    uk: `Не вдалось виконати операцію`,
    ru: `Не удалось выполнить операцию`,
    eng: `Failed to perform operation`,
  },
  ls_common_otp_confirmation_permanent_error_message: {
    uk: `Не вдалось виконати операцію. Будь ласка, спробуйте повторити операцію пізніше.`,
    ru: `Не удалось выполнить операцию. Пожалуйста, попробуйте повторить операцию позже.`,
    eng: `Failed to perform the operation. Please try again later.`,
  },
  ls_start_screen_maintenance_title: {
    uk: `В системі йдуть технічні роботи`,
    ru: `В системе идут технические работы`,
    eng: `System under maintenance`,
  },
  ls_start_screen_maintenance_message: {
    uk: `Спробуйте увійти до системи через деякий час.`,
    ru: `Попробуйте войти в систему через некоторое время.`,
    eng: `Try to sing in to the system after a while.`,
  },
  ls_common_amount_limit_error_title: {
    uk: `Некоректна сума`,
    ru: `Некорректная сумма`,
    eng: `Incorrect amount`,
  },
  ls_common_amount_limit_error_message: {
    uk: `Сума платежу має бути в межах від `,
    ru: `Сумма должна быть в пределах от `,
    eng: `Amount should be from `,
  },
  ls_common_amount_limit_error_to: {
    uk: `до `,
    ru: `до `,
    eng: `up to `,
  },
  ls_common_amount_limit_error_try_again: {
    uk: `Змініть суму та спробуйте ще раз.`,
    ru: `Измените сумму и попробуйте еще раз.`,
    eng: `Change the amount and try again.`,
  },
  ls_common_no_valid_accounts_text: {
    uk: `Немає відповідних рахунків`,
    ru: `Нет подходящих счетов`,
    eng: `No appropriate accounts`,
  },
  ls_deposit_dashboard_interest_accrued_label: {
    uk: `Проценти (нараховані)`,
    ru: `Проценты (начисленные)`,
    eng: `Interest (accrued)`,
  },
  ls_deposit_dashboard_rate_label: {
    uk: `Cтавка: `,
    ru: `Cтавка: `,
    eng: `Rate: `,
  },
  ls_deposit_dashboard_term_label: {
    uk: `Строк депозиту до`,
    ru: `Срок депозита до`,
    eng: `Deposit term until`,
  },
  ls_deposit_dashboard_sum_label: {
    uk: `Сума депозиту`,
    ru: `Сумма депозита`,
    eng: `Deposit amount`,
  },
  ls_deposit_dashboard_term_expired_label: {
    uk: `Скінчився`,
    ru: `Закончился`,
    eng: `Expired`,
  },
  ls_acc2acc_widget_title: {
    uk: `Переказ між рахунками`,
    ru: `Перевод между счетами`,
    eng: `Transfer between accounts`,
  },
  ls_common_transfer_to_account_button: {
    uk: `Платіж за реквізитами`,
    ru: `Платеж по реквизитам`,
    eng: `Transfer to requisites`,
  },
  ls_signup_screen_title: {
    uk: `Реєстрація в системі Інтернет-банкінгу`,
    ru: `Регистрация в системе Интернет-банкинга`,
    eng: `Registration in Internet banking`,
  },
  ls_signup_form_phone_field_label: {
    uk: `Номер мобільного телефону`,
    ru: `Номер мобильного телефона`,
    eng: `Mobile phone number`,
  },
  ls_signup_agree_with_text: {
    uk: `Я погоджуюсь з `,
    ru: `Я соглашаюсь с `,
    eng: `I agree with the `,
  },
  ls_signup_conditions_url_text: {
    uk: `Умовами банківського обслуговування`,
    ru: `Условиями банковского обслуживания`,
    eng: `Terms of bank service`,
  },
  ls_signup_conditions_url_address: {
    uk: `https://poltavabank.com/platizhni-kartky/#1599833079089-ac012fab-7041`,
    ru: `https://poltavabank.com/platizhni-kartky/#1599833079089-ac012fab-7041`,
    eng: `https://poltavabank.com/platizhni-kartky/#1599833079089-ac012fab-7041`,
  },
  ls_signup_form_login_cta: {
    uk: `Вже зареєстровані?`,
    ru: `Уже зарегистрированы?`,
    eng: `Already registered?`,
  },
  ls_signup_form_login_cta_link: {
    uk: `Увійти в систему.`,
    ru: `Войти в систему.`,
    eng: `Log in to system.`,
  },
  ls_signup_button_normal: {
    uk: `Реєстрація`,
    ru: `Регистрация`,
    eng: `Sign up`,
  },
  ls_signup_button_loading: {
    uk: `В обробці`,
    ru: `В обработке`,
    eng: `Processing`,
  },
  ls_set_password_title: {
    uk: `Будь ласка, оберіть постійний пароль для входу в систему.`,
    ru: `Пожалуйста, выберите постоянный пароль входа в систему.`,
    eng: `Please, choose a static password for your account.`,
  },
  ls_identification_screen_title: {
    uk: `Ідентифікація клієнта`,
    ru: `Идентификация клиента`,
    eng: `Customer identification`,
  },
  ls_identification_screen_text_message: {
    uk: `Введіть номер вашої платіжної картки, щоб завершити реєстрацію та отримати доступ до застосунку.`,
    ru: `Введите номер вашей карты, чтобы завершить регистрацию и получить доступ к приложению.`,
    eng: `Enter your card number to finish the sign up and obtain access to the application.`,
  },
  ls_identification_card_field_placeholder: {
    uk: `Введіть номер картки`,
    ru: `Введите номер карты`,
    eng: `Enter card number`,
  },
  ls_identification_get_access_button_normal: {
    uk: `Отримати доступ`,
    ru: `Получить доступ`,
    eng: `Get access`,
  },
  ls_identification_get_access_button_loading: {
    uk: `В обробці`,
    ru: `В обработке`,
    eng: `Processing`,
  },
  ls_identification_success_title: {
    uk: `Реєстрація успішна!`,
    ru: `Регистрация успешна!`,
    eng: `Registration successful!`,
  },
  ls_identification_screen_success_message: {
    uk: `Тепер ви можете скористатись функціоналом мобільного банкінгу.`,
    ru: `Теперь вы можете воспользоваться функционалом мобильного банкинга.`,
    eng: `Now you can use the features of mobile banking.`,
  },
  ls_identification_next_button_normal: {
    uk: `Продовжити`,
    ru: `Продолжить`,
    eng: `Continue`,
  },
  ls_identification_next_button_loading: {
    uk: `В обробці`,
    ru: `В обработке`,
    eng: `Processing`,
  },
  ls_signup_wrong_username_error_title: {
    uk: `Недійсний номер`,
    ru: `Недействительный номер`,
    eng: `Invalid number`,
  },
  ls_signup_wrong_username_error_message: {
    uk: `Ви ввели недійсний номер телефону. Перевірте введені дані та спробуйте ще раз.`,
    ru: `Вы ввели не действительный номер телефона. Проверьте введенные данные и попробуйте еще раз.`,
    eng: `The phone number you enter is not valid. Please check your entry and try again.`,
  },
  ls_signup_phone_registered_error_title: {
    uk: `Номер вже зареєстровано`,
    ru: `Номер уже зарегистрирован`,
    eng: `Number already registered`,
  },
  ls_signup_phone_registered_error_message: {
    uk: `Цей номер телефону вже зареєстрований. Будь ласка, увійдіть до додатку, використовуючи свій пароль.`,
    ru: `Этот номер телефона уже зарегистрирован. Пожалуйста, войдите в приложение, используя свой пароль.`,
    eng: `This phone number is already registered. Please log in to the application using your password.`,
  },
  ls_common_operation_failed_error_title: {
    uk: `Невдала операція`,
    ru: `Операция неуспешна`,
    eng: `Operation failed`,
  },
  ls_common_operation_failed_error_message: {
    uk: `Не вдалось виконати операцію. Будь ласка, спробуйте ще раз.`,
    ru: `Не удалось выполнить операцию. Пожалуйста, попробуйте еще раз.`,
    eng: `Unable to perform operation. Please try again.`,
  },
  ls_common_otp_confirmation_otp_expired_error: {
    uk: `Термін дії коду скінчився. Спробуйте ще раз.`,
    ru: `Срок действия кода исчерпан. Попробуйте еще раз.`,
    eng: `The code has expired. Please try again.`,
  },
  ls_common_otp_confirmation_time_expired_error: {
    uk: `Час очікування минув. Ви можете запросити повторну відправку коду.`,
    ru: `Время ожидания истекло. Вы можете запросить повторную отправку кода.`,
    eng: `Waiting time has expired. You can request a new code.`,
  },
  ls_common_otp_confirmation_wrong_otp_error: {
    uk: `Введено невірний код. Перевірте введені дані та спробуйте ще раз.`,
    ru: `Введен неверный код. Проверьте введенные данные и попробуйте еще раз.`,
    eng: `Incorrect confirmation code.Check your entry and try again.`,
  },
  ls_identification_wrong_card_error_title: {
    uk: `Невірний номер картки`,
    ru: `Неверный номер карты`,
    eng: `Incorrect card number`,
  },
  ls_payment_to_requisites_screen_title: {
    uk: `Платіж за реквізитами`,
    ru: `Платеж по реквизитам`,
    eng: `Transfer to requisites`,
  },
  ls_common_pay_from_account_field_label: {
    uk: `Переказати з рахунку`,
    ru: `Перевести со счета`,
    eng: `Transfer from account`,
  },
  ls_payment_to_requisites_name_field_label: {
    uk: `П.І.Б. чи назва організації`,
    ru: `Ф.И.О. или название организации`,
    eng: `Full name or company name`,
  },
  ls_payment_to_requisites_name_field_placeholder: {
    uk: `П.І.Б. або назва організації`,
    ru: `Ф.И.О. или название организации`,
    eng: `Full name or company name`,
  },
  ls_payment_to_requisites_account_number_field_label: {
    uk: `Номер рахунку отримувача`,
    ru: `Номер счета получателя`,
    eng: `Receiver's account number`,
  },
  ls_payment_to_requisites_account_number_field_placeholder: {
    uk: `Введіть від 5 до 14 цифр`,
    ru: `Введите от 5 до 14 цифр`,
    eng: `Enter from 5 to 14 digits`,
  },
  ls_payment_to_requisites_taxid_field_label: {
    uk: `ІПН/ЄДРПОУ отримувача`,
    ru: `ИНН/ЕГРПОУ получателя`,
    eng: `Receiver's IPN/EDRPOU`,
  },
  ls_payment_to_requisites_taxid_field_placeholder: {
    uk: `Введіть від 8 до 10 цифр`,
    ru: `Введите от 8 до 10 цифр`,
    eng: `Enter from 8 to 10 digits`,
  },
  ls_payment_to_requisites_bank_code_field_label: {
    uk: `Код банку отримувача`,
    ru: `Код банка получателя`,
    eng: `Receiver's bank code`,
  },
  ls_payment_to_requisites_bank_code_field_placeholder: {
    uk: `Введіть 6 цифр`,
    ru: `Введите 6 цифр`,
    eng: `Enter 6 digits`,
  },
  ls_payment_to_requisites_bank_name_field_label: {
    uk: `Назва банка отримувача`,
    ru: `Название банка получателя`,
    eng: `Receiver's bank name`,
  },
  ls_payment_to_requisites_bank_name_field_placeholder: {
    uk: `Заповнюється автоматично`,
    ru: `Заполняется автоматически`,
    eng: `Filled automatically`,
  },
  ls_payment_to_requisites_purpose_field_label: {
    uk: `Призначення платежу`,
    ru: `Назначение платежа`,
    eng: `Purpose of payment`,
  },
  ls_payment_to_requisites_purpose_field_placeholder: {
    uk: `Введіть не менше 15 знаків`,
    ru: `Введите не менее 15 знаков`,
    eng: `Enter 15 symbols or more`,
  },
  ls_payment_to_requisites_next_button_normal: {
    uk: `Переказати`,
    ru: `Перевести`,
    eng: `Transfer`,
  },
  ls_payment_to_requisites_name_field_format_error: {
    uk: `Має містити від 3 до 38 символів`,
    ru: `Должно содержать от 3 до 38 символов`,
    eng: `Must contain from 3 to 38 symbols`,
  },
  ls_payment_to_requisites_taxid_field_format_error: {
    uk: `Має містити від 8 до 10 цифр`,
    ru: `Должно содержать от 8 до 10 цифр`,
    eng: `Must contain from 8 to 10 digits`,
  },
  ls_payment_to_requisites_account_number_field_format_error: {
    uk: `Має містити від 5 до 14 цифр`,
    ru: `Должно содержать от 5 до 14 цифр`,
    eng: `Must contain from 5 to 14 digits`,
  },
  ls_payment_to_requisites_bank_code_field_format_error: {
    uk: `Невірний код банку`,
    ru: `Неверный код банка`,
    eng: `Incorrect bank code`,
  },
  ls_payment_to_requisites_purpose_field_format_error: {
    uk: `Має містити від 15 до 160 символів`,
    ru: `Должно содержать от 15 до 160 символов`,
    eng: `Must contain from 15 to 160 symbols`,
  },
  ls_payment_to_requisites_bank_code_field_digits_error: {
    uk: `Має містити 6 цифр`,
    ru: `Должен содержать 6 цифр`,
    eng: `Must contain 6 digits`,
  },
  ls_payment_to_requisites_bank_code_not_found_error: {
    uk: `Не знайдено`,
    ru: `Не найден`,
    eng: `Not found`,
  },
  ls_payment_to_requisites_ipn_label: {
    uk: `ІПН/ЄДРПОУ: `,
    ru: `ИНН/ЕГРПОУ: `,
    eng: `Tax ID: `,
  },
  ls_payment_to_requisites_bank_code_label: {
    uk: `МФО: `,
    ru: `МФО: `,
    eng: `Bank code: `,
  },
  ls_payment_to_requisites_account_label: {
    uk: `Р/р: `,
    ru: `Р/с: `,
    eng: `Acc: `,
  },
  ls_common_save_template_button_label: {
    uk: `Зберегти як шаблон`,
    ru: `Сохранить как шаблон`,
    eng: `Save as template`,
  },
  ls_currency_converter_sell_currency_message: {
    uk: `При розрахунку використовується поточний курс покупки банком обраної іноземної валюти.`,
    ru: `При расчете используется текущий курс покупки банком выбранной иностранной валюты.`,
    eng: `Current bank sell rate for selected currency is used for calculation.`,
  },
  ls_currency_converter_buy_currency_message: {
    uk: `При розрахунку використовується поточний курс покупки банком обраної іноземної валюти.`,
    ru: `При расчете используется текущий курс продажи банком выбранной иностранной валюты.`,
    eng: `Current bank buy rate for selected currency is used for calculation.`,
  },
  ls_currency_converter_convert_currency_message: {
    uk: `Розрахунок проводиться як продаж вихідної валюти з наступною покупкою валюти конвертації за виручену суму в національній валюті.`,
    ru: `Расчет производится как продажа исходной валюты с последующей покупкой валюты конвертации за вырученную сумму в национальной валюте.`,
    eng: `The calculation is performed as a sale of the original currency followed by the purchase of the conversion currency with received national currency.`,
  },
  ls_currency_converter_EUR_full_name: {
    uk: `Євро (Європейський союз)`,
    ru: `Евро (Европейский союз)`,
    eng: `EUR (European union)`,
  },
  ls_currency_converter_USD_full_name: {
    uk: `Долар США`,
    ru: `Доллар США`,
    eng: `US Dollar`,
  },
  ls_currency_converter_GBP_full_name: {
    uk: `Фунт стерлінгів`,
    ru: `Фунт стерлингов`,
    eng: `Pound sterling`,
  },
  ls_currency_converter_UAH_full_name: {
    uk: `Українська гривня`,
    ru: `Украинская гривна`,
    eng: `Ukrainian hryvnia`,
  },
  ls_currency_converter_same_currency_error: {
    uk: `Оберіть валюту, для якої необхідно виконати розрахунок.`,
    ru: `Выберите валюту, для которой необходимо выполнить расчет.`,
    eng: `Select a currency for which you want perform the calculation.`,
  },
  ls_order_product_menu_item_text: {
    uk: `Замовити новий продукт`,
    ru: `Заказать новый продукт`,
    eng: `Order new product`,
  },
  ls_common_full_name_label: {
    uk: `ПІБ: `,
    ru: `ФИО: `,
    eng: `Name: `,
  },
  ls_common_ipn_edrpou_label: {
    uk: `ІПН/ЄДРПОУ: `,
    ru: `ИНН/ЕГРПОУ: `,
    eng: `Tax ID: `,
  },
  ls_common_bank_name_placeholder: {
    uk: `АТ “Полтава-Банк“`,
    ru: `АО “Полтава-Банк“`,
    eng: `JSC “Poltava-bank”`,
  },
  ls_common_iban_label: {
    uk: `IBAN: `,
    ru: `IBAN: `,
    eng: `IBAN: `,
  },
  ls_common_swift_label: {
    uk: `SWIFT: `,
    ru: `SWIFT: `,
    eng: `SWIFT: `,
  },
  ls_common_share_button: {
    uk: `Надіслати`,
    ru: `Переслать`,
    eng: `Send`,
  },
  ls_generating_receipt_dialog_title: {
    uk: `Формування квитанції`,
    ru: `Формирование квитанции`,
    eng: `Generating receipt`,
  },
  ls_send_pdf_dialog_title: {
    uk: `Надіслати виписку`,
    ru: `Отправить выписку`,
    eng: `Send statement`,
  },
  ls_send_pdf_dialog_message: {
    uk: `Введіть Email на який бажаєте отримати виписку`,
    ru: `Введите Email на который желаете получить выписку`,
    eng: `Enter an Email to send the statement to`,
  },
  ls_send_pdf_email_field_label: {
    uk: `Надіслати на Email`,
    ru: `Отправить на Email`,
    eng: `Send to Email`,
  },
  ls_send_pdf_email_field_placeholder: {
    uk: `Введіть адресу`,
    ru: `Введите адрес`,
    eng: `Enter address`,
  },
  ls_send_pdf_dialog_send_button_label: {
    uk: `Надіслати`,
    ru: `Переслать`,
    eng: `Send`,
  },
  ls_generating_statement_dialog_title: {
    uk: `Замовлення виписки`,
    ru: `Заказ выписки`,
    eng: `Ordering statement`,
  },
  ls_generating_statement_success_dialog_title: {
    uk: `Виписка замовлена`,
    ru: `Выписка заказана`,
    eng: `Statement ordered`,
  },
  ls_generating_statement_success_dialog_message: {
    uk: `Очікуйте надходження виписки на електронну пошту найближчим часом.`,
    ru: `Ожидайте поступления выписки на электронную почту в ближайшее время.`,
    eng: `Await the arrival of the statement to the specified email in the nearest time.`,
  },
  ls_transfer_to_card_button_label: {
    uk: `Переказ на картку Полтава-банк`,
    ru: `Перевод на карту Полтава-банк`,
    eng: `Transfer to Poltava-bank card`,
  },
  ls_account_to_card_screen_title: {
    uk: `Переказ на картку Полтава-банк`,
    ru: `Перевод на карту Полтава-банк`,
    eng: `Transfer to Poltava-bank card`,
  },
  ls_account_to_card_from_account_field_label: {
    uk: `Переказати з рахунку`,
    ru: `Перевести со счета`,
    eng: `Transfer from account`,
  },
  ls_account_to_card_number_field_label: {
    uk: `Номер картки отримувача`,
    ru: `Номер карты получателя`,
    eng: `Receiver's card number`,
  },
  ls_account_to_card_number_field_placeholder: {
    uk: `Введіть 16 цифр номеру картки`,
    ru: `Введите 16 цифр номера карты`,
    eng: `Enter 16 digit card number`,
  },
  ls_common_uah_currency: {
    uk: `UAH`,
    ru: `UAH`,
    eng: `UAH`,
  },
  ls_payment_error_wrong_card_number_message: {
    uk: `Вказано невірний номер картки отримувача. Перевірте введені дані і спробуйте ще раз.`,
    ru: `Указан неверный номер карты получателя. Проверьте введенные данные и попробуйте еще раз.`,
    eng: `Wrong card number. Please check your entry and try again. `,
  },
  ls_account_to_card_card_number_field_error: {
    uk: `Має містити 16 цифр`,
    ru: `Должно содержать 16 цифр`,
    eng: `Must contain 16 digits`,
  },
  ls_payment_error_wrong_card_number_title: {
    uk: `Невірний номер картки`,
    ru: `Неверный номе карты`,
    eng: `Wrong card number`,
  },
  ls_account_to_card_receiver_name_placeholder: {
    uk: `Картка отримувача`,
    ru: `Карта получателя`,
    eng: `Receiver's card`,
  },
  ls_cancel_operation_button_normal: {
    uk: `Скасувати платіж`,
    ru: `Отменить платеж`,
    eng: `Cancel payment`,
  },
  ls_cancel_operation_dialog_title: {
    uk: `Скасувати платіж`,
    ru: `Отменить платеж`,
    eng: `Cancel payment`,
  },
  ls_common_dialog_revoke_button: {
    uk: `Скасувати`,
    ru: `Отменить`,
    eng: `Cancel`,
  },
  ls_cancel_operation_success_message: {
    uk: `Обраний платіж скасовано.`,
    ru: `Обраний платіж скасовано.`,
    eng: `Обраний платіж скасовано.`,
  },
  ls_common_refill_from_another_bank_button: {
    uk: `Переказ з картки іншого банку`,
    ru: `Перевод с карты другого банка`,
    eng: `Transfer from another bank card`,
  },
  ls_profile_account_type_customer: {
    uk: `Клієнт Полтава-банк`,
    ru: `Клиент Полтава-банк`,
    eng: `Poltava-bank client`,
  },
  ls_common_online_chat_button: {
    uk: `Онлайн чат`,
    ru: `Онлайн чат`,
    eng: `Online chat`,
  },
  ls_common_messages_button: {
    uk: `Повідомлення`,
    ru: `Сообщения`,
    eng: `Messages`,
  },
  ls_save_template_dialog_title: {
    uk: `Зберегти як шаблон`,
    ru: `Сохранить как шаблон`,
    eng: `Save as template`,
  },
  ls_template_name_field_label: {
    uk: `Назва шаблону`,
    ru: `Название шаблона`,
    eng: `Template name`,
  },
  ls_template_name_dialog_input_placeholder: {
    uk: `Мій шаблон`,
    ru: `Мой шаблон`,
    eng: `My template`,
  },
  ls_template_saved_dialog_title: {
    uk: `Шаблон успішно збережено!`,
    ru: `Шаблон успешно сохранен!`,
    eng: `Template saved successfully!`,
  },
  ls_template_saved_dialog_message: {
    uk: `Використовуйте збережені шаблони, щоб прискорити проведення платежів.`,
    ru: `Используйте сохраненные шаблоны, чтобы ускорить проведение платежей.`,
    eng: `Use saved templates to speed up payments.`,
  },
  ls_template_delete_dialog_title: {
    uk: `Видалити шаблон`,
    ru: `Удалить шаблон`,
    eng: `Delete template`,
  },
  ls_template_delete_dialog_message: {
    uk: `Ви дійсно бажаєте видалити цей шаблон?`,
    ru: `Вы действительно хотите удалить этот шаблон?`,
    eng: `Are you sure you want to delete this template?`,
  },
  ls_templates_screen_title: {
    uk: `Шаблони`,
    ru: `Шаблоны`,
    eng: `Templates`,
  },
  ls_templates_screen_empty_title: {
    uk: `У вас ще немає шаблонів платежів`,
    ru: `У вас еще нет шаблонов платежей`,
    eng: `No payment templates yet`,
  },
  ls_templates_screen_empty_message: {
    uk: `Ви можете зберегти новий шаблон під час здійснення нового платежу.`,
    ru: `Вы можете сохранить новый шаблон во время проведения нового платежа.`,
    eng: `You can save a new template while making a new payment.`,
  },
  ls_common_save_template_link_label: {
    uk: `Зберегти шаблон`,
    ru: `Сохранить шаблон`,
    eng: `Save template`,
  },
  ls_template_details_pay_button_normal: {
    uk: `Сплатити`,
    ru: `Оплатить`,
    eng: `Pay`,
  },
  ls_common_template_payment_button: {
    uk: `Платіж по шаблону`,
    ru: `Платеж по шаблону`,
    eng: `Template payment`,
  },
  ls_periodic_payments_menu_item_text: {
    uk: `Періодичні платежі`,
    ru: `Периодические платежи`,
    eng: `Periodic payments`,
  },
  ls_periodic_payments_screen_title: {
    uk: `Періодичні платежі`,
    ru: `Периодические платежи`,
    eng: `Periodic payments`,
  },
  ls_periodic_payments_empty_message_title: {
    uk: `У вас ще немає періодичних платежів`,
    ru: `У вас еще нет периодических платежей`,
    eng: `You do not have any periodic payments`,
  },
  ls_periodic_payments_empty_message_text: {
    uk: `Щоб створити новий періодичний платіж натисніть на кнопку Платіж за реквізитами.`,
    ru: `Чтобы создать новый периодический платеж нажмите на кнопку Платеж по реквизитам.`,
    eng: `To create a new periodic payment press the Transfer to requisites button.`,
  },
  ls_periodic_payments_recurring_label: {
    uk: `Періодичні`,
    ru: `Периодические`,
    eng: `Periodic`,
  },
  ls_periodic_payments_one_time_label: {
    uk: `Майбутня дата`,
    ru: `Будущая дата`,
    eng: `Future date`,
  },
  ls_periodic_payment_parameters_widget_title: {
    uk: `Параметри платежу`,
    ru: `Параметры платежа`,
    eng: `Payment parameters`,
  },
  ls_periodic_payment_frequency_field_label: {
    uk: `Періодичність платежу`,
    ru: `Периодичность платежа`,
    eng: `Payment frequency`,
  },
  ls_periodic_payment_frequency_field_monthly_option: {
    uk: `Щомісячно`,
    ru: `Ежемесячно`,
    eng: `Monthly`,
  },
  ls_periodic_payment_frequency_field_weekly_option: {
    uk: `Щотижнево`,
    ru: `Еженедельно`,
    eng: `Weekly`,
  },
  ls_periodic_payment_frequency_field_once_option: {
    uk: `Разовий платіж`,
    ru: `Разовый платеж`,
    eng: `One time payment`,
  },
  ls_periodic_payment_first_payment_date_field_label: {
    uk: `Дата першого платежу`,
    ru: `Дата первого платежа`,
    eng: `First payment date`,
  },
  ls_periodic_payment_first_payment_date_field_placeholder: {
    uk: `Оберіть дату`,
    ru: `Выберите дату`,
    eng: `Select date`,
  },
  ls_periodic_payment_last_payment_date_field_label: {
    uk: `Дата останнього платежу`,
    ru: `Дата последнего платежа`,
    eng: `Last payment date`,
  },
  ls_periodic_payment_last_payment_date_field_placeholder: {
    uk: `Оберіть дату`,
    ru: `Выберите дату`,
    eng: `Select date`,
  },
  ls_periodic_payment_single_payment_date_field_label: {
    uk: `Дата майбутнього платежу`,
    ru: `Дата будущего платежа`,
    eng: `Future payment date`,
  },
  ls_periodic_payment_single_payment_date_field_placeholder: {
    uk: `Оберіть дату`,
    ru: `Выберите дату`,
    eng: `Select date`,
  },
  ls_periodic_payment_next_button_normal: {
    uk: `Створити платіж`,
    ru: `Создать платеж`,
    eng: `Create payment`,
  },
  ls_periodic_payment_select_period_screen_title: {
    uk: `Періодичність платежу`,
    ru: `Периодичность платежа`,
    eng: `Payment frequency`,
  },
  ls_periodic_payment_confirmation_notice_text: {
    uk: `Дані платежі обробляються банком в робочі дні з 8:00.`,
    ru: `Данные платежи обрабатываются банком в рабочие дни с 8:00.`,
    eng: `This type of payment will be processed on working days starting from 8:00.`,
  },
  ls_periodic_payment_success_message_text: {
    uk: `Платіж та його налаштування будуть доступні в розділі Платежі – Періодичні платежі.`,
    ru: `Платеж и его настройки будут доступны в разделе Платежи – Периодические платежи.`,
    eng: `The payment and it's settings will be available in Payments – Periodic payments.`,
  },
  ls_periodic_payment_pay_now_button_normal: {
    uk: `Сплатити зараз`,
    ru: `Оплатить сейчас`,
    eng: `Pay now`,
  },
  ls_delete_periodic_payment_dialog_title: {
    uk: `Видалення платежу`,
    ru: `Удаление платежа`,
    eng: `Deleting payment`,
  },
  ls_delete_periodic_payment_dialog_message: {
    uk: `Ви дійсно бажаєте видалити цей платіж?`,
    ru: `Вы действительно хотите удалить этот платеж?`,
    eng: `Are you sure you want to delete this payment?`,
  },
  ls_order_card_screen_title: {
    uk: `Замовити картку`,
    ru: `Заказать карту`,
    eng: `Order card`,
  },
  ls_common_order_button_normal: {
    uk: `Замовити картку`,
    ru: `Заказать карту`,
    eng: `Order card`,
  },
  ls_card_type_selector_label: {
    uk: `Тип картки`,
    ru: `Тип карты`,
    eng: `Card type`,
  },
  ls_card_currency_label: {
    uk: `Валюта картки`,
    ru: `Валюта карты`,
    eng: `Card currency`,
  },
  ls_currency_selector_label_UAH: {
    uk: `UAH`,
    ru: `UAH`,
    eng: `UAH`,
  },
  ls_currency_selector_label_EUR: {
    uk: `EUR`,
    ru: `EUR`,
    eng: `EUR`,
  },
  ls_currency_selector_label_USD: {
    uk: `USD`,
    ru: `USD`,
    eng: `USD`,
  },
  ls_order_card_new_card_selector_label: {
    uk: `Нова картка`,
    ru: `Новая карта`,
    eng: `New card`,
  },
  ls_order_card_additional_card_selector_label: {
    uk: `Додаткова картка`,
    ru: `Дополнительная`,
    eng: `Additional card`,
  },
  ls_card_tariff_url_label: {
    uk: `Детальна інформація про тариф`,
    ru: `Детальная информация про тариф`,
    eng: `Detailed information on tariff`,
  },
  ls_card_type_label: {
    uk: `Клас`,
    ru: `Класс`,
    eng: `Class`,
  },
  ls_card_type_selector_title: {
    uk: `Клас картки`,
    ru: `Класс карты`,
    eng: `Card class`,
  },
  ls_order_card_tariff_label: {
    uk: `Тариф`,
    ru: `Тариф`,
    eng: `Tariff`,
  },
  ls_order_card_code_phrase_field_label: {
    uk: `Секретне слово`,
    ru: `Секретное слово`,
    eng: `Secret word`,
  },
  ls_order_card_code_phrase_field_placeholder: {
    uk: `Введіть секретне слово`,
    ru: `Введите секретное слово`,
    eng: `Enter secret word`,
  },
  ls_card_order_pay_from_account_label: {
    uk: `Сплатити з рахунку`,
    ru: `Оплатить со счета`,
    eng: `Pay from account`,
  },
  ls_card_issue_cost_label: {
    uk: `Вартість випуску`,
    ru: `Стоимость выпуска`,
    eng: `Issuing fee`,
  },
  ls_common_agree_with_text: {
    uk: `Я погоджуюсь з `,
    ru: `Я соглашаюсь с `,
    eng: `I agree with the `,
  },
  ls_card_order_tariff_confitions_url_text: {
    uk: `Умовами обслуговування обраного тарифу`,
    ru: `Условиями обслуживания по выбранному тарифу`,
    eng: `Service conditions for chosen tariff`,
  },
  ls_order_card_code_phrase_field_error: {
    uk: `Має містити не менше 5 літер`,
    ru: `Должно содержать не менее 5 букв`,
    eng: `Must contain at least 5 letters`,
  },
  ls_order_card_select_main_card_field_label: {
    uk: `Виберіть основну картку`,
    ru: `Выберите основную карту`,
    eng: `Select primary card`,
  },
  ls_reissue_card_option_label: {
    uk: `Перевипуск`,
    ru: `Перевыпуск`,
    eng: `Reissue`,
  },
  ls_reissue_card_screen_title: {
    uk: `Перевипуск картки`,
    ru: `Перевыпуск карты`,
    eng: `Card reissue`,
  },
  ls_reissue_card_next_button_normal: {
    uk: `Перевипустити`,
    ru: `Перевыпустить`,
    eng: `Reissue`,
  },
  ls_change_card_credit_limit_widget_title: {
    uk: `Змінити кредитний ліміт`,
    ru: `Изменить кредитный лимит`,
    eng: `Change credit limit`,
  },
  ls_change_card_credit_limit_new_limit_label: {
    uk: `Новий ліміт`,
    ru: `Новый лимит`,
    eng: `New limit`,
  },
  ls_change_card_credit_limit_current_limit_label: {
    uk: `Поточний кредитний ліміт`,
    ru: `Текущий кредитный лимит`,
    eng: `Current credit limit`,
  },
  ls_change_card_credit_limit_button_label: {
    uk: `Змінити ліміт`,
    ru: `Изменить лимит`,
    eng: `Change limit`,
  },
  ls_new_credit_button_label: {
    uk: `Заявка на кредит`,
    ru: `Заявка на кредит`,
    eng: `Apply for credit`,
  },
  ls_new_credit_desired_amount_label: {
    uk: `Бажана сума кредиту: `,
    ru: `Желаемая сумма кредита: `,
    eng: `Desired credit amount: `,
  },
  ls_new_credit_term_in_month_label: {
    uk: `Строк в місяцях`,
    ru: `Срок в месяцах`,
    eng: `Term in months`,
  },
  ls_new_credit_employment_label: {
    uk: `Працевлаштування`,
    ru: `Трудоустройства`,
    eng: `Employment`,
  },
  ls_new_credit_purpose_label: {
    uk: `Мета кредиту`,
    ru: `Цель кредита`,
    eng: `Credit purpose`,
  },
  ls_new_credit_confitions_url_text: {
    uk: `Умовами оформлення онлайн-заявки та перевіркою моїх персональних даних`,
    ru: `Условиями оформления онлайн-заявки и проверкой моих персональных данных`,
    eng: `Conditions of online application and check up of my personal data`,
  },
  ls_new_credit_submit_application_button_label: {
    uk: `Подати заявку`,
    ru: `Подать заявку`,
    eng: `Submit application`,
  },
  ls_new_credit_term_twelve_months_option: {
    uk: `12 місяців`,
    ru: `12 месяцев`,
    eng: `12 months`,
  },
  ls_new_credit_term_eighteen_months_option: {
    uk: `18 місяців`,
    ru: `18 месяцев`,
    eng: `18 months`,
  },
  ls_new_credit_term_twenty_four_months_option: {
    uk: `24 місяці`,
    ru: `24 месяцев`,
    eng: `24 months`,
  },
  ls_new_credit_term_thirty_months_option: {
    uk: `30 місяців`,
    ru: `30 месяцев`,
    eng: `30 months`,
  },
  ls_new_credit_term_thirty_six_months_option: {
    uk: `36 місяців`,
    ru: `36 месяцев`,
    eng: `36 months`,
  },
  ls_new_credit_employment_type_1: {
    uk: `Працюю неофіційно`,
    ru: `Работаю неофициально`,
    eng: `Working unofficially`,
  },
  ls_new_credit_employment_type_2: {
    uk: `Офіційне працевлаштування`,
    ru: `Официальное трудоустройство`,
    eng: `Official employment`,
  },
  ls_new_credit_employment_type_3: {
    uk: `Отримую зарплату в “Полтава-Банк“`,
    ru: `Получаю зарплату в “Полтава-банк“`,
    eng: `Receiving salary in JSC “Poltava-bank“`,
  },
  ls_new_credit_employment_type_4: {
    uk: `СПД/ФОП/ПП`,
    ru: `СПД/ФЛП/ЧП`,
    eng: `SPD/FOP/PP`,
  },
  ls_new_credit_employment_type_5: {
    uk: `Пенсіонер`,
    ru: `Пенсионер`,
    eng: `Pensioner`,
  },
  ls_new_credit_employment_type_6: {
    uk: `Тимчасово не працюю`,
    ru: `Временно не работаю`,
    eng: `Temporarily unemployed`,
  },
  ls_new_credit_employment_type_7: {
    uk: `Військовослужбовець`,
    ru: `Военнослужащий`,
    eng: `Military service`,
  },
  ls_new_credit_employment_type_8: {
    uk: `Працюю за договором підряду`,
    ru: `Работаю по договору подряда`,
    eng: `Working under a contract`,
  },
  ls_new_credit_employment_screen_title: {
    uk: `Працевлаштування`,
    ru: `Трудоустройство`,
    eng: `Employment`,
  },
  ls_new_credit_purpose_screen_title: {
    uk: `Мета кредиту`,
    ru: `Цель кредита`,
    eng: `Credit purpose`,
  },
  ls_new_credit_purpose_type_1: {
    uk: `На перекредитування`,
    ru: `На перекредитование`,
    eng: `For credit refinancing`,
  },
  ls_new_credit_purpose_type_2: {
    uk: `На бізнес`,
    ru: `На бизнес`,
    eng: `For business`,
  },
  ls_new_credit_purpose_type_3: {
    uk: `На ремонт`,
    ru: `На ремонт`,
    eng: `For repairs`,
  },
  ls_new_credit_purpose_type_4: {
    uk: `На купівлю товарів`,
    ru: `На покупку товаров`,
    eng: `For goods purchase`,
  },
  ls_new_credit_purpose_type_5: {
    uk: `На відпочинок`,
    ru: `На отдых`,
    eng: `For vacation`,
  },
  ls_new_credit_purpose_type_6: {
    uk: `Інше`,
    ru: `Другое`,
    eng: `Other`,
  },
  ls_new_credit_purpose_type_7: {
    uk: `На лікування`,
    ru: `На лечение`,
    eng: `For medical treatment`,
  },
  ls_new_credit_confirmation_title: {
    uk: `Заявка на кредит`,
    ru: `Заявка на кредит`,
    eng: `Apply for credit`,
  },
  ls_new_credit_term_short_label_option: {
    uk: `Строк: `,
    ru: `Срок: `,
    eng: `Term: `,
  },
  ls_new_credit_approximate_monthly_payment_text: {
    uk: `Орієнтовна щомісячна сума платежу за кредитом складатиме `,
    ru: `Ориентировочная ежемесячная сумма платежа по кредиту составит `,
    eng: `Approximate monthly credit repayment amount will be `,
  },
  ls_new_credit_success_title: {
    uk: `Заявку на кредит надіслано`,
    ru: `Заявка на кредит отправлена`,
    eng: `Credit application sent`,
  },
  ls_deposits_screen_empty_message_title: {
    uk: `У вас ще немає депозитів`,
    ru: `У вас еще нет депозитов`,
    eng: `You don't have any deposits yet`,
  },
  ls_deposits_screen_empty_message_text: {
    uk: `Інформація про ваші депозити з’явиться тут, коли ви відкриєте депозит в нашому Банку.`,
    ru: `Информация о ваших депозитах появится здесь, когда вы откроете депозит в нашем Банке.`,
    eng: `Information on your deposits will appear here, when you open a deposit in our Bank.`,
  },
  ls_common_open_deposit_button_normal: {
    uk: `Відкрити депозит`,
    ru: `Открыть депозит`,
    eng: `Open a deposit`,
  },
  ls_deposit_term_termless_option: {
    uk: `Безстроковий`,
    ru: `Бессрочный`,
    eng: `Termless`,
  },
  ls_deposit_term_until_label: {
    uk: `До `,
    ru: `До `,
    eng: `Until `,
  },
  ls_deposit_term_expired_text: {
    uk: `Термін скінчився`,
    ru: `Срок закончился`,
    eng: `Expired`,
  },
  ls_deposit_interest_short_label: {
    uk: `Проценти:  `,
    ru: `Проценты: `,
    eng: `Interest: `,
  },
  ls_deposit_interest_available_label: {
    uk: `Проценти (доступні): `,
    ru: `Проценты (доступные): `,
    eng: `Interest (available): `,
  },
  ls_deposit_interest_accrued_label: {
    uk: `Проценти (нараховані): `,
    ru: `Проценты (начисленные): `,
    eng: `Interest (accrued): `,
  },
  ls_deposit_details_history_tab_label: {
    uk: `Історія операцій`,
    ru: `История операций`,
    eng: `Operation history`,
  },
  ls_deposit_details_schedule_tab_label: {
    uk: `Графік`,
    ru: `График`,
    eng: `Schedule`,
  },
  ls_deposit_contract_number_field_label: {
    uk: `Договір №: `,
    ru: `Договор №: `,
    eng: `Contract #: `,
  },
  ls_deposit_details_term_field_label: {
    uk: `Строк: `,
    ru: `Срок: `,
    eng: `Term: `,
  },
  ls_deposit_request_contract_copy_label: {
    uk: `Замовити доставку договору`,
    ru: `Заказать доставку договора`,
    eng: `Order copy of contract`,
  },
  ls_deposit_rate_label: {
    uk: `Процентна ставка: `,
    ru: `Процентная ставка: `,
    eng: `Interest rate: `,
  },
  ls_deposit_interest_payout_field_label: {
    uk: `Виплата відсотків: `,
    ru: `Выплата процентов: `,
    eng: `Interest payout: `,
  },
  ls_deposit_interest_payout_unknown_label: {
    uk: `Невідомо`,
    ru: `Неизвестно`,
    eng: `Unknown`,
  },
  ls_deposit_interest_payout_unset_label: {
    uk: `Не встановлено`,
    ru: `Не установлено`,
    eng: `Not set`,
  },
  ls_deposit_interest_payout_daily_label: {
    uk: `Щоденно`,
    ru: `Ежедневно`,
    eng: `Daily`,
  },
  ls_deposit_interest_payout_weekly_label: {
    uk: `Щотижнево`,
    ru: `Еженедельно`,
    eng: `Weekly`,
  },
  ls_deposit_interest_payout_monthly_label: {
    uk: `Щомісячно`,
    ru: `Ежемесячно`,
    eng: `Monthly`,
  },
  ls_deposit_interest_payout_yearly_label: {
    uk: `Щорічно`,
    ru: `Ежегодно`,
    eng: `Yearly`,
  },
  ls_deposit_interest_payout_end_of_term_label: {
    uk: `В кінці терміну`,
    ru: `В конце срока`,
    eng: `End of term`,
  },
  ls_deposit_interest_payout_quarter_label: {
    uk: `Щоквартально`,
    ru: `Ежеквартально`,
    eng: `Quarterly`,
  },
  ls_deposit_interest_payout_half_year_label: {
    uk: `Щопівроку`,
    ru: `Каждые полгода`,
    eng: `Biannual`,
  },
  ls_deposit_interest_payout_advance_label: {
    uk: `Авансом`,
    ru: `Авансом`,
    eng: `In advance`,
  },
  ls_deposit_interest_payout_monthly_capital_label: {
    uk: `Щомісячно (капіталізація)`,
    ru: `Ежемесячно (капитализ.)`,
    eng: `Monthly (capitalization)`,
  },
  ls_deposit_refill_label: {
    uk: `Поповнення: `,
    ru: `Пополнение: `,
    eng: `Refill: `,
  },
  ls_deposit_withdraw_label: {
    uk: `Часткове зняття: `,
    ru: `Частичное снятие: `,
    eng: `Partial withdrawal: `,
  },
  ls_common_yes_option: {
    uk: `Так`,
    ru: `Да`,
    eng: `Yes`,
  },
  ls_common_no_option: {
    uk: `Ні`,
    ru: `Нет`,
    eng: `No`,
  },
  ls_deposit_prolongation_label: {
    uk: `Пролонгація депозиту: `,
    ru: `Пролонгация депозита: `,
    eng: `Deposit prolongation: `,
  },
  ls_deposit_capitalization_field_label: {
    uk: `Капіталізація процентів: `,
    ru: `Капитализация процентов: `,
    eng: `Interest capitalization: `,
  },
  ls_deposit_initial_amount_label: {
    uk: `Початкова сума: `,
    ru: `Начальная сумма: `,
    eng: `Initial amount: `,
  },
  ls_deposit_current_amount_label: {
    uk: `Поточна сума: `,
    ru: `Текущая сумма: `,
    eng: `Current amount: `,
  },
  ls_deposit_interest_available_field_label: {
    uk: `Проценти (доступні): `,
    ru: `Проценты (доступные): `,
    eng: `Interest (available): `,
  },
  ls_deposit_interest_accrued_field_label: {
    uk: `Проценти (нараховані): `,
    ru: `Проценты (начисленные): `,
    eng: `Interest (accrued): `,
  },
  ls_deposit_return_account_number_field_label: {
    uk: `Рахунок для виплат: `,
    ru: `Счет для выплат: `,
    eng: `Deposit payout account: `,
  },
  ls_deposit_schedule_interest_payout_label: {
    uk: `Виплата процентів`,
    ru: `Выплата процентов`,
    eng: `Interest payout`,
  },
  ls_deposit_schedule_interest_payout_date_label: {
    uk: `Дата виплати: `,
    ru: `Дата выплаты: `,
    eng: `Payout date: `,
  },
  ls_deposit_open_deposit_message_title: {
    uk: `Відкрийте новий депозит`,
    ru: `Откройте новый депозит`,
    eng: `Open a new deposit`,
  },
  ls_deposit_open_deposit_message_text: {
    uk: `Відкрийте депозит зараз та дозвольте вашим заощадженням працювати на вас.`,
    ru: `Откройте депозит сейчас и позвольте вашим сбережения работать на вас.`,
    eng: `Open a deposit now and let your savings work for you.`,
  },
  ls_common_refill_deposit_button_normal: {
    uk: `Поповнити депозит`,
    ru: `Пополнить депозит`,
    eng: `Refill deposit`,
  },
  ls_common_withdraw_deposit_button_normal: {
    uk: `Зняти депозит`,
    ru: `Снять депозит`,
    eng: `Withdraw deposit`,
  },
  ls_deposit_history_empty_message_text: {
    uk: `Немає нещодавніх операцій`,
    ru: `Нет недавних операций`,
    eng: `No recent operations`,
  },
  ls_deposit_return_account_empty_label: {
    uk: `Натисніть тут, щоб обрати рахунок`,
    ru: `Нажмите здесь, чтобы выбрать счет`,
    eng: `Tap here to select an account`,
  },
  ls_deposit_return_account_selection_screen_title: {
    uk: `Рахунок для виплат`,
    ru: `Счет для выплат`,
    eng: `Deposit payout account`,
  },
  ls_common_changing_settings_dialog_title: {
    uk: `Зміна налаштувань`,
    ru: `Смена настроек`,
    eng: `Changing settings`,
  },
  ls_deposit_return_account_warning_title: {
    uk: `Увага!`,
    ru: `Внимание!`,
    eng: `Attention!`,
  },
  ls_deposit_return_account_warning_message: {
    uk: `При використанні цього рахунку може стягуватись комісія при здійсненні платежів з депозиту. Натисніть ЗБЕРЕГТИ, щоб продовжити.`,
    ru: `При использовании этого счета, может взиматься комиссия при проведении платежей с депозита. Нажмите СОХРАНИТЬ, чтобы продолжить.`,
    eng: `Using this account may lead to fees when making payments from the deposits. Press SAVE to continue.`,
  },
  ls_common_dialog_continue_button: {
    uk: `Продовжити`,
    ru: `Продолжить`,
    eng: `Continue`,
  },
  ls_deposit_rename_name_field_label: {
    uk: `Назва депозиту`,
    ru: `Название депозита`,
    eng: `Deposit name`,
  },
  ls_refill_deposit_screen_title: {
    uk: `Поповнити депозит`,
    ru: `Пополнить депозит`,
    eng: `Refill deposit`,
  },
  ls_refill_deposit_widget_title: {
    uk: `Поповнити депозит`,
    ru: `Пополнить депозит`,
    eng: `Refill deposit`,
  },
  ls_refill_deposit_payment_next_button_normal: {
    uk: `Переказати`,
    ru: `Перевести`,
    eng: `Transfer`,
  },
  ls_common_amount_limit_from: {
    uk: `(від `,
    ru: `(от `,
    eng: `(from `,
  },
  ls_common_amount_limit_to: {
    uk: ` до `,
    ru: ` до `,
    eng: ` to `,
  },
  ls_common_amount_limit_separate_from: {
    uk: `від`,
    ru: `от`,
    eng: `from`,
  },
  ls_common_amount_limit_separate_to: {
    uk: `до`,
    ru: `до`,
    eng: `to`,
  },
  ls_deposit_details_accrued_interest_hint: {
    uk: `Проценти, нараховані за весь період дії договору`,
    ru: `Проценты начисленные за весь период действия договора`,
    eng: `Interest accrued during the whole period of contract validity`,
  },
  ls_deposit_rename_dialog_title: {
    uk: `Змінити назву`,
    ru: `Сменить название`,
    eng: `Change name`,
  },
  ls_withdraw_deposit_screen_title: {
    uk: `Зняти з депозиту`,
    ru: `Снять с депозита`,
    eng: `Withdraw deposit`,
  },
  ls_withdraw_from_deposit_widget_title: {
    uk: `Зняти з депозиту`,
    ru: `Снять с депозита`,
    eng: `Withdraw deposit`,
  },
  ls_new_deposit_screen_title: {
    uk: `Новий депозит`,
    ru: `Новый депозит`,
    eng: `New deposit`,
  },
  ls_new_deposit_screen_subtitle: {
    uk: `Оберіть бажані умови депозиту`,
    ru: `Выберите желаемые условия депозита`,
    eng: `Choose desired deposit conditions`,
  },
  ls_find_deposit_currency_label: {
    uk: `Валюта депозиту:`,
    ru: `Валюта депозита:`,
    eng: `Deposit currency:`,
  },
  ls_common_usd_currency: {
    uk: `USD`,
    ru: `USD`,
    eng: `USD`,
  },
  ls_common_eur_currency: {
    uk: `EUR`,
    ru: `EUR`,
    eng: `EUR`,
  },
  ls_find_deposit_interest_payout_label: {
    uk: `Виплата процентів:`,
    ru: `Выплата процентов:`,
    eng: `Interest payout:`,
  },
  ls_common_irrelevant_option: {
    uk: `Всі опції`,
    ru: `Все опции`,
    eng: `All options`,
  },
  ls_find_deposit_interest_payout_monthly_option: {
    uk: `Щомісячно`,
    ru: `Ежемесячно`,
    eng: `Monthly`,
  },
  ls_find_deposit_interest_payout_daily_option: {
    uk: `Щоденно`,
    ru: `Ежедневно`,
    eng: `Daily`,
  },
  ls_find_deposit_interest_payout_weekly_option: {
    uk: `Щотижнево`,
    ru: `Еженедельно`,
    eng: `Weekly`,
  },
  ls_find_deposit_interest_payout_yearly_option: {
    uk: `Щорічно`,
    ru: `Ежегодно`,
    eng: `Yearly`,
  },
  ls_find_deposit_interest_payout_monthly_capital_option: {
    uk: `Щомісячно (капіталізація)`,
    ru: `Ежемесячно (капитализ.)`,
    eng: `Monthly (capitalization)`,
  },
  ls_find_deposit_interest_payout_end_of_term_option: {
    uk: `В кінці терміну`,
    ru: `В конце срока`,
    eng: `End of term`,
  },
  ls_find_deposit_refill_label: {
    uk: `Поповнення:`,
    ru: `Пополнение:`,
    eng: `Refill:`,
  },
  ls_find_deposit_withdrawal_label: {
    uk: `Часткове зняття:`,
    ru: `Частичное снятие:`,
    eng: `Partial withdrawal:`,
  },
  ls_find_deposit_screen_message: {
    uk: `Оберіть депозитний вклад, строк та процентну ставку`,
    ru: `Выберите депозитный вклад, срок и процентную ставку`,
    eng: `Choose a deposit, term and interest rate`,
  },
  ls_find_deposit_programs_name_term_label: {
    uk: `Назва вкладу / Строк`,
    ru: `Название / Срок`,
    eng: `Deposit name / Term`,
  },
  ls_deposit_term_one_month_option: {
    uk: `1 міс.`,
    ru: `1 мес.`,
    eng: `1 mon.`,
  },
  ls_deposit_term_three_month_option: {
    uk: `3 міс.`,
    ru: `3 мес.`,
    eng: `3 mon.`,
  },
  ls_deposit_term_six_month_option: {
    uk: `6 міс.`,
    ru: `6 мес.`,
    eng: `6 mon.`,
  },
  ls_deposit_term_twelve_month_option: {
    uk: `12 міс.`,
    ru: `12 мес.`,
    eng: `12 mon.`,
  },
  ls_deposit_term_one_month_full_text_option: {
    uk: `1 місяць`,
    ru: `1 месяц`,
    eng: `1 month`,
  },
  ls_deposit_term_three_month_full_text_option: {
    uk: `3 місяці`,
    ru: `3 месяца`,
    eng: `3 months`,
  },
  ls_deposit_term_six_month_full_text_option: {
    uk: `6 місяців`,
    ru: `6 месяцев`,
    eng: `6 months`,
  },
  ls_deposit_term_twelve_month_full_text_option: {
    uk: `12 місяців`,
    ru: `12 месяцев`,
    eng: `12 months`,
  },
  ls_find_deposit_programs_action_label: {
    uk: `Дія`,
    ru: `Действие`,
    eng: `Action`,
  },
  ls_find_deposit_programs_select_label: {
    uk: `Обрати`,
    ru: `Выбрать`,
    eng: `Choose`,
  },
  ls_find_deposit_term_termless_option: {
    uk: `Безстроковий`,
    ru: `Бессрочный`,
    eng: `Termless`,
  },
  ls_common_loading_message: {
    uk: `Завантаження`,
    ru: `Загрузка`,
    eng: `Loading`,
  },
  ls_common_form_change_label: {
    uk: `Змінити`,
    ru: `Изменить`,
    eng: `Edit`,
  },
  ls_new_deposit_type_label: {
    uk: `Тип депозиту`,
    ru: `Тип депозита`,
    eng: `Deposit type`,
  },
  ls_new_deposit_currency_label: {
    uk: `Валюта депозиту`,
    ru: `Валюта депозита`,
    eng: `Deposit currency`,
  },
  ls_new_deposit_term_in_month_label: {
    uk: `Строк в місяцях`,
    ru: `Срок в месяцах`,
    eng: `Term in months`,
  },
  ls_new_deposit_interest_rate_label: {
    uk: `Процентна ставка`,
    ru: `Процентная ставка`,
    eng: `Interest rate`,
  },
  ls_new_deposit_withdraw_label: {
    uk: `Дострокове зняття`,
    ru: `Досрочное снятие`,
    eng: `Early withdrawal`,
  },
  ls_new_deposit_refill_label: {
    uk: `Поповнення`,
    ru: `Пополнение`,
    eng: `Refill`,
  },
  ls_new_deposit_interest_payout_label: {
    uk: `Виплата процентів`,
    ru: `Выплата процентов`,
    eng: `Interest payout`,
  },
  ls_new_deposit_prolongation_label: {
    uk: `Пролонгація депозиту`,
    ru: `Пролонгация депозита`,
    eng: `Deposit prolongation`,
  },
  ls_new_deposit_term_label: {
    uk: `Строк депозиту`,
    ru: `Срок депозита`,
    eng: `Deposit term`,
  },
  ls_new_deposit_term_days_plural_form1: {
    uk: `днів`,
    ru: `дней`,
    eng: `days`,
  },
  ls_new_deposit_term_days_plural_form2: {
    uk: `дні`,
    ru: `дня`,
    eng: `days`,
  },
  ls_new_deposit_term_days_singular_form: {
    uk: `день`,
    ru: `день`,
    eng: `day`,
  },
  ls_new_deposit_prolongation_auto_option: {
    uk: `Автоматично`,
    ru: `Автоматически`,
    eng: `Automatic`,
  },
  ls_new_deposit_prolongation_unavailable_option: {
    uk: `Не передбачено`,
    ru: `Не предусмотрено`,
    eng: `Not applicable`,
  },
  ls_new_deposit_capitalization_field_label: {
    uk: `Капіталізація процентів`,
    ru: `Капитализация процентов`,
    eng: `Interest capitalization`,
  },
  ls_new_deposit_pay_from_account_label: {
    uk: `Переказати з рахунку`,
    ru: `Перевести со счета`,
    eng: `Transfer from account`,
  },
  ls_new_deposit_return_account_label: {
    uk: `Рахунок повернення депозиту`,
    ru: `Счет возврата депозита`,
    eng: `Deposit return account`,
  },
  ls_new_deposit_min_amount_text: {
    uk: `Мінімальна сума вкладу: `,
    ru: `Минимальная сумма вклада: `,
    eng: `Minimum deposit amount: `,
  },
  ls_new_deposit_agree_to_terms_text: {
    uk: `Я погоджуюсь з умовами обраного вкладу, `,
    ru: `Я соглашаюсь с условиями выбранного вклада, `,
    eng: `I agree to the conditions of the chosen deposit, `,
  },
  ls_new_deposit_service_terms_url_text: {
    uk: `Правилами банківського обслуговування`,
    ru: `Правилами банковского обслуживания`,
    eng: `Terms of bank service`,
  },
  ls_new_deposit_and_text: {
    uk: `, `,
    ru: `, `,
    eng: `, `,
  },
  ls_new_deposit_application_contract_url_text: {
    uk: `підтверджую отримання довідки ФГВФО`,
    ru: `подтверждаю получение справки ФГВФЛ`,
    eng: `confirm the receipt of the DGF reference`,
  },
  ls_new_deposit_service_terms_url: {
    uk: `https://poltavabank.com/doc/%D0%9F%D1%80%D0%B8%D0%B2%D0%B0%D1%82%D0%BD%D0%B8%D0%BC%20%D0%BE%D1%81%D0%BE%D0%B1%D0%B0%D0%BC/%D0%9F%D0%BE%D1%82%D0%BE%D1%87%D0%BD%D1%96%20%D1%80%D0%B0%D1%85%D1%83%D0%BD%D0%BA%D0%B8/%D0%94%D0%BE%D0%B3%D0%BE%D0%B2%D1%96%D1%80/%D0%A3%D0%BD%D1%96%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D0%B8%D0%B9%20%D0%94%D0%BE%D0%B3%D0%BE%D0%B2%D1%96%D1%80%20%D0%B1%D0%B0%D0%BD%D0%BA%D1%96%D0%B2%D1%81%D1%8C%D0%BA%D0%BE%D0%B3%D0%BE%20%D0%BE%D0%B1%D1%81%D0%BB%D1%83%D0%B3%D0%BE%D0%B2%D1%83%D0%B2%D0%B0%D0%BD%D0%BD%D1%8F%20%D0%BA%D0%BB%D1%96%D1%94%D0%BD%D1%82%D1%96%D0%B2%20-%20%D1%84%D1%96%D0%B7%D0%B8%D1%87%D0%BD%D0%B8%D1%85%20%D0%BE%D1%81%D1%96%D0%B1.pdf`,
    ru: `https://poltavabank.com/doc/%D0%9F%D1%80%D0%B8%D0%B2%D0%B0%D1%82%D0%BD%D0%B8%D0%BC%20%D0%BE%D1%81%D0%BE%D0%B1%D0%B0%D0%BC/%D0%9F%D0%BE%D1%82%D0%BE%D1%87%D0%BD%D1%96%20%D1%80%D0%B0%D1%85%D1%83%D0%BD%D0%BA%D0%B8/%D0%94%D0%BE%D0%B3%D0%BE%D0%B2%D1%96%D1%80/%D0%A3%D0%BD%D1%96%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D0%B8%D0%B9%20%D0%94%D0%BE%D0%B3%D0%BE%D0%B2%D1%96%D1%80%20%D0%B1%D0%B0%D0%BD%D0%BA%D1%96%D0%B2%D1%81%D1%8C%D0%BA%D0%BE%D0%B3%D0%BE%20%D0%BE%D0%B1%D1%81%D0%BB%D1%83%D0%B3%D0%BE%D0%B2%D1%83%D0%B2%D0%B0%D0%BD%D0%BD%D1%8F%20%D0%BA%D0%BB%D1%96%D1%94%D0%BD%D1%82%D1%96%D0%B2%20-%20%D1%84%D1%96%D0%B7%D0%B8%D1%87%D0%BD%D0%B8%D1%85%20%D0%BE%D1%81%D1%96%D0%B1.pdf`,
    eng: `https://poltavabank.com/doc/%D0%9F%D1%80%D0%B8%D0%B2%D0%B0%D1%82%D0%BD%D0%B8%D0%BC%20%D0%BE%D1%81%D0%BE%D0%B1%D0%B0%D0%BC/%D0%9F%D0%BE%D1%82%D0%BE%D1%87%D0%BD%D1%96%20%D1%80%D0%B0%D1%85%D1%83%D0%BD%D0%BA%D0%B8/%D0%94%D0%BE%D0%B3%D0%BE%D0%B2%D1%96%D1%80/%D0%A3%D0%BD%D1%96%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D0%B8%D0%B9%20%D0%94%D0%BE%D0%B3%D0%BE%D0%B2%D1%96%D1%80%20%D0%B1%D0%B0%D0%BD%D0%BA%D1%96%D0%B2%D1%81%D1%8C%D0%BA%D0%BE%D0%B3%D0%BE%20%D0%BE%D0%B1%D1%81%D0%BB%D1%83%D0%B3%D0%BE%D0%B2%D1%83%D0%B2%D0%B0%D0%BD%D0%BD%D1%8F%20%D0%BA%D0%BB%D1%96%D1%94%D0%BD%D1%82%D1%96%D0%B2%20-%20%D1%84%D1%96%D0%B7%D0%B8%D1%87%D0%BD%D0%B8%D1%85%20%D0%BE%D1%81%D1%96%D0%B1.pdf`,
  },
  ls_new_deposit_application_contract_url: {
    uk: `https://poltavabank.com/doc/%D0%9F%D1%80%D0%B8%D0%B2%D0%B0%D1%82%D0%BD%D0%B8%D0%BC%20%D0%BE%D1%81%D0%BE%D0%B1%D0%B0%D0%BC/%D0%A4%D0%BE%D0%BD%D0%B4%20%D0%B3%D0%B0%D1%80%D0%B0%D0%BD%D1%82%D1%83%D0%B2%D0%B0%D0%BD%D0%BD%D1%8F%20%D0%B2%D0%BA%D0%BB%D0%B0%D0%B4%D1%96%D0%B2/%D0%94%D0%BE%D0%B2%D1%96%D0%B4%D0%BA%D0%B0.pdf`,
    ru: `https://poltavabank.com/doc/%D0%9F%D1%80%D0%B8%D0%B2%D0%B0%D1%82%D0%BD%D0%B8%D0%BC%20%D0%BE%D1%81%D0%BE%D0%B1%D0%B0%D0%BC/%D0%A4%D0%BE%D0%BD%D0%B4%20%D0%B3%D0%B0%D1%80%D0%B0%D0%BD%D1%82%D1%83%D0%B2%D0%B0%D0%BD%D0%BD%D1%8F%20%D0%B2%D0%BA%D0%BB%D0%B0%D0%B4%D1%96%D0%B2/%D0%94%D0%BE%D0%B2%D1%96%D0%B4%D0%BA%D0%B0.pdf`,
    eng: `https://poltavabank.com/doc/%D0%9F%D1%80%D0%B8%D0%B2%D0%B0%D1%82%D0%BD%D0%B8%D0%BC%20%D0%BE%D1%81%D0%BE%D0%B1%D0%B0%D0%BC/%D0%A4%D0%BE%D0%BD%D0%B4%20%D0%B3%D0%B0%D1%80%D0%B0%D0%BD%D1%82%D1%83%D0%B2%D0%B0%D0%BD%D0%BD%D1%8F%20%D0%B2%D0%BA%D0%BB%D0%B0%D0%B4%D1%96%D0%B2/%D0%94%D0%BE%D0%B2%D1%96%D0%B4%D0%BA%D0%B0.pdf`,
  },
  ls_new_deposit_button_normal: {
    uk: `Відкрити депозит`,
    ru: `Открыть депозит`,
    eng: `Open deposit`,
  },
  ls_new_deposit_button_loading: {
    uk: `В обробці`,
    ru: `В обработке`,
    eng: `Processing`,
  },
  ls_new_deposit_confirm_rate_label: {
    uk: `Cтавка: `,
    ru: `Ставка: `,
    eng: `Rate: `,
  },
  ls_new_deposit_confirm_contract_date_label: {
    uk: `Дата договору: `,
    ru: `Дата договора: `,
    eng: `Contract date: `,
  },
  ls_new_deposit_confirm_term_label: {
    uk: `Термін: `,
    ru: `Срок: `,
    eng: `Term: `,
  },
  ls_new_deposit_confirm_term_termless: {
    uk: `Безстроковий`,
    ru: `Бессрочный`,
    eng: `Termless`,
  },
  ls_common_since_text: {
    uk: ` з `,
    ru: ` с `,
    eng: ` from `,
  },
  ls_new_deposit_confirm_interest_payout_label: {
    uk: `Виплата процентів: `,
    ru: `Выплата процентов: `,
    eng: `Interest payout: `,
  },
  ls_new_deposit_no_accounts_in_selected_currency_text: {
    uk: `Немає рахунків в обраній валюті`,
    ru: `Нет счетов в выбранной валюте`,
    eng: `No accounts in selected currency`,
  },
  ls_new_deposit_amount_less_than_minimum_error: {
    uk: `Сума менша за мінімальну суму вкладу`,
    ru: `Сумма меньше минимальной суммы вклада`,
    eng: `Amount is less than minimum deposit amount`,
  },
  ls_find_deposit_no_suitable_deposit_error: {
    uk: `Не знайдено вкладів, що відповідають заданим умовам `,
    ru: `Не найдены вклады, отвечающие заданным условиям.`,
    eng: `No suitable deposits found under chosen parameters`,
  },
  ls_credits_screen_title: {
    uk: `Кредити`,
    ru: `Кредиты`,
    eng: `Credits`,
  },
  ls_credits_screen_empty_message_title: {
    uk: `У вас ще немає кредитів`,
    ru: `У вас еще нет кредитов`,
    eng: `You don't have any credits yet`,
  },
  ls_credits_screen_empty_message_text: {
    uk: `Інформація про ваші кредити з’явиться тут, коли ви відкриєте кредит в нашому Банку.`,
    ru: `Информация о ваших кредитах появится здесь, когда вы откроете кредит в нашем Банке.`,
    eng: `Information on your credits will appear here, when you open a credit in our Bank.`,
  },
  ls_credits_list_rate_label: {
    uk: `Ставка: `,
    ru: `Ставка: `,
    eng: `Rate: `,
  },
  ls_credit_details_term_field_label: {
    uk: `Строк: `,
    ru: `Срок: `,
    eng: `Term: `,
  },
  ls_credits_details_contract_number_label: {
    uk: `Договір №: `,
    ru: `Договор №: `,
    eng: `Contract #: `,
  },
  ls_credit_widget_until_short_label: {
    uk: `Сплатити до `,
    ru: `Оплатить до `,
    eng: `Pay until `,
  },
  ls_credits_list_term_until: {
    uk: `До `,
    ru: `До `,
    eng: `Until `,
  },
  ls_credits_details_planned_payment_until_label: {
    uk: ` до `,
    ru: ` до `,
    eng: ` until `,
  },
  ls_credits_schedule_payment_until_label: {
    uk: `Сплатити до: `,
    ru: `Оплатить до: `,
    eng: `Pay until: `,
  },
  ls_credits_details_planned_payment_amount_label: {
    uk: `Наступний платіж: `,
    ru: `Следующий платеж: `,
    eng: `Next payment: `,
  },
  ls_credits_details_monthly_fee_label: {
    uk: `Щомісячна комісія: `,
    ru: `Ежемесячная комиссия: `,
    eng: `Monthly fee: `,
  },
  ls_credits_details_rate_label: {
    uk: `Процентна ставка: `,
    ru: `Процентная ставка: `,
    eng: `Interest rate: `,
  },
  ls_credits_details_initial_amount_label: {
    uk: `Початкова сума: `,
    ru: `Начальная сумма: `,
    eng: `Initial amount: `,
  },
  ls_credits_details_current_amount_label: {
    uk: `Поточна сума: `,
    ru: `Текущая сумма: `,
    eng: `Current amount: `,
  },
  ls_credits_details_regular_payment_account_label: {
    uk: `Рахунок для регулярного платежу: `,
    ru: `Счет для регулярного платежа: `,
    eng: `Regular payment account: `,
  },
  ls_credits_details_preliminary_payment_account_label: {
    uk: `Рахунок для дострокового платежу: `,
    ru: `Счет для досрочного платежа: `,
    eng: `Preliminary payment account: `,
  },
  ls_credits_details_repay_credit_button_normal: {
    uk: `Погасити кредит`,
    ru: `Погасить кредит`,
    eng: `Repay credit`,
  },
  ls_credit_rename_name_field_label: {
    uk: `Назва кредиту`,
    ru: `Название кредита`,
    eng: `Credit name`,
  },
  ls_credit_rename_dialog_title: {
    uk: `Змінити назву`,
    ru: `Сменить название`,
    eng: `Change name`,
  },
  ls_repay_credit_screen_title: {
    uk: `Погасити кредит`,
    ru: `Погасить кредит`,
    eng: `Repay credit`,
  },
  ls_credit_payment_details_widget_title: {
    uk: `Деталі платежу`,
    ru: `Детали платежа`,
    eng: `Payment details`,
  },
  ls_credits_widget_no_action_empty_message: {
    uk: `Зверніться до Банку, щоб отримати кредит і здійснити покупки, про які мрієте.`,
    ru: `Обратитесь в Банк, чтобы получить кредит и совершить покупки, о которых мечтаете.`,
    eng: `Contact the Bank to obtain a credit and make the purchases you are dreaming of.`,
  },
  ls_credit_widget_credit_amount_label: {
    uk: `Сума кредиту`,
    ru: `Сумма кредита`,
    eng: `Credit amount`,
  },
  ls_credit_widget_next_payment_label: {
    uk: `Наступний платіж`,
    ru: `Следующий платеж`,
    eng: `Next payment`,
  },
  ls_credit_history_empty_message_text: {
    uk: `Немає нещодавніх операцій`,
    ru: `Нет недавних операций`,
    eng: `No recent operations`,
  },
  ls_repay_credit_payment_next_button_normal: {
    uk: `Переказати`,
    ru: `Перевести`,
    eng: `Transfer`,
  },
  ls_repay_credit_general_debt_title: {
    uk: `Основний борг`,
    ru: `Основной долг`,
    eng: `General debt`,
  },
  ls_repay_credit_interest_title: {
    uk: `Відсотки`,
    ru: `Проценты`,
    eng: `Interest`,
  },
  ls_repay_credit_fee_payment_title: {
    uk: `Комісія`,
    ru: `Комиссия`,
    eng: `Fee`,
  },
  s_repay_credit_penalty_title: {
    uk: `Пеня`,
    ru: `Пеня`,
    eng: `Penalty`,
  },
  ls_repay_credit_fine_title: {
    uk: `Штраф`,
    ru: `Штраф`,
    eng: `Fine`,
  },
  ls_repay_credit_current_amount_text: {
    uk: `Поточний:  `,
    ru: `Текущий: `,
    eng: `Current: `,
  },
  ls_repay_credit_overdue_amount_text: {
    uk: ` + Прострочений: `,
    ru: ` + Просроченный: `,
    eng: ` + Overdue: `,
  },
  ls_repay_credit_payment_type_text: {
    uk: `Погасити кредит`,
    ru: `Погасить кредит`,
    eng: `Repay credit`,
  },
  ls_repay_credit_from_account_label: {
    uk: `Переказати з рахунку`,
    ru: `Перевести со счета`,
    eng: `Transfer from account`,
  },
  ls_repay_credit_payment_details_control_normal: {
    uk: `Деталі платежу`,
    ru: `Детали платежа`,
    eng: `Payment details`,
  },
  ls_repay_credit_pay_button_normal: {
    uk: `Переказати`,
    ru: `Перевести`,
    eng: `Transfer`,
  },
  ls_demo_version_dialog_title: {
    uk: `Демо версія`,
    ru: `Демо версия`,
    eng: `Demo version`,
  },
  ls_demo_version_hint_message_text: {
    uk: `Проведення операцій недоступне в демонстраційній версії. Для виходу з демо режиму натисніть Вийти в головному меню.`,
    ru: `Проведение операций недоступно в демонстрационной версии. Для выхода из демо режима нажмите Выйти в главном меню.`,
    eng: `Operations can not be performed in demo version. To leave the demo mode press Log out in the main menu.`,
  },
  ls_common_okay_dialog_button: {
    uk: `Добре`,
    ru: `Хорошо`,
    eng: `Okay`,
  },
  ls_common_button_loading: {
    uk: `В обробці`,
    ru: `В обработке`,
    eng: `Processing`,
  },
  ls_currency_widget_exchange_currency_button_label: {
    uk: `Обмін валют`,
    ru: `Обмен валют`,
    eng: `Currency exchange`,
  },
  ls_currency_exchange_action_label: {
    uk: `Обмін валют`,
    ru: `Обмен валют`,
    eng: `Currency exchange`,
  },
  ls_currency_exchange_screen_title: {
    uk: `Обмін валют`,
    ru: `Обмен валют`,
    eng: `Currency exchange`,
  },
  ls_currency_exchange_sell_tab_label: {
    uk: `Продати`,
    ru: `Продать`,
    eng: `Sell`,
  },
  ls_currency_exchange_buy_tab_label: {
    uk: `Купити`,
    ru: `Купить`,
    eng: `Buy`,
  },
  ls_currency_exchange_currency_amount_header: {
    uk: `Валюта та сума`,
    ru: `Валюта и сумма`,
    eng: `Currency and amount`,
  },
  ls_currency_exchange_enter_amount_title: {
    uk: `Введіть суму для обміну`,
    ru: `Введите сумму для обмена`,
    eng: `Enter amount to exchange`,
  },
  ls_currency_exchange_rate_field_label: {
    uk: `Курс: `,
    ru: `Курс: `,
    eng: `Rate: `,
  },
  ls_currency_exchange_rate_fee_label: {
    uk: `Комісія: `,
    ru: `Комиссия: `,
    eng: `Fee: `,
  },
  ls_currency_exchange_transfer_from_account_widget_title: {
    uk: `Списати з рахунку`,
    ru: `Списать со счета`,
    eng: `Transfer from account`,
  },
  ls_currency_exchange_transfer_to_account_widget_title: {
    uk: `Зарахувати на рахунок`,
    ru: `Зачислить на счет`,
    eng: `Transfer to account`,
  },
  ls_currency_exchange_transfer_button_normal: {
    uk: `Переказати`,
    ru: `Перевести`,
    eng: `Transfer`,
  },
  ls_currency_exchange_currency_selector_usd_label: {
    uk: `USD`,
    ru: `USD`,
    eng: `USD`,
  },
  ls_currency_exchange_currency_selector_eur_label: {
    uk: `EUR`,
    ru: `EUR`,
    eng: `EUR`,
  },
  ls_currency_exchange_transfer_from_card_dialog_title: {
    uk: `Списати з рахунку`,
    ru: `Списать со счета`,
    eng: `Transfer from account`,
  },
  ls_currency_exchange_transfer_to_card_dialog_title: {
    uk: `Зарахувати на рахунок`,
    ru: `Зачислить на счет`,
    eng: `Transfer to account`,
  },
  ls_currency_exchange_insufficient_funds_error: {
    uk: `Недостатньо коштів на обраному рахунку.`,
    ru: `Недостаточно средств на выбранном счете.`,
    eng: `Not enough funds on selected account.`,
  },
  ls_currency_exchange_maximum_amount_error: {
    uk: `Максимальна сума `,
    ru: `Максимальная сумма `,
    eng: `Maximum amount `,
  },
  ls_currency_exchange_unable_to_load_data_error: {
    uk: `Не вдалося отримати дані.`,
    ru: `Не удалось получить данные.`,
    eng: `Unable to obtain data.`,
  },
  ls_currency_exchange_no_internet_access_error: {
    uk: `Немає доступу до Інтернет`,
    ru: `Нет доступа к Интернет`,
    eng: `No internet access`,
  },
  ls_common_account_not_found_message: {
    uk: `Рахунок не знайдено`,
    ru: `Счет не найден`,
    eng: `Account not found`,
  },
  ls_payment_to_requisites_iban_account_number_field_label: {
    uk: `Рахунок або IBAN отримувача`,
    ru: `Счет или IBAN получателя`,
    eng: `Receiver's account or IBAN number`,
  },
  ls_payment_to_requisites_iban_account_number_field_placeholder: {
    uk: `Введіть від 5 до 29 символів`,
    ru: `Введите от 5 до 29 символов`,
    eng: `Enter from 5 to 29 symbols`,
  },
  ls_payment_to_requisites_iban_bank_code_field_placeholder: {
    uk: `Автозаповнення`,
    ru: `Автозаполнение`,
    eng: `Autofill`,
  },
  ls_payment_to_requisites_iban_bank_name_field_placeholder: {
    uk: `Автозаповнення`,
    ru: `Автозаполнение`,
    eng: `Autofill`,
  },
  ls_payment_to_requisites_iban_number_field_format_error: {
    uk: `IBAN має починатись з UA та містити ще 27 цифр`,
    ru: `IBAN должен начинаться с UA и содержать еще 27 цифр`,
    eng: `IBAN must begin with UA and contain 27 more digits`,
  },
  ls_payment_to_requisites_iban_account_number_field_format_error: {
    uk: `Номер рахунку має містити від 5 до 14 цифр`,
    ru: `Номер счета должен содержать от 5 до 14 цифр`,
    eng: `Account number must contain from 5 to 14 digits`,
  },
  ls_payment_to_requisites_bank_name_not_found_error: {
    uk: `Не знайдено`,
    ru: `Не найден`,
    eng: `Not found`,
  },
  ls_refill_from_another_bank_card_screen_title: {
    uk: `Переказ з картки іншого банку`,
    ru: `Перевод с карты другого банка`,
    eng: `Transfer from another bank card`,
  },
  ls_pay_from_card_widget_title: {
    uk: `Переказати з картки`,
    ru: `Перевести с карты`,
    eng: `Pay from card`,
  },
  ls_common_press_to_add_other_bank_card_hint: {
    uk: `Натисніть, щоб додати картку іншого банку`,
    ru: `Нажмите, чтобы добавить карту другого банка`,
    eng: `Tap to add a card of another bank`,
  },
  ls_add_card_dialog_title: {
    uk: `Додати картку`,
    ru: `Добавить карту`,
    eng: `Add card`,
  },
  ls_add_card_success_title: {
    uk: `Картку успішно додано!`,
    ru: `Карта успешно добавлена!`,
    eng: `Card added successfully!`,
  },
  ls_add_card_success_message: {
    uk: `Тепер ви можете скористатись вашою карткою для здійснення платежів.`,
    ru: `Теперь вы можете использовать вашу карту для проведения платежей.`,
    eng: `Now you can use your card to make payments. `,
  },
  ls_add_card_already_added_error_message: {
    uk: `Ця картка вже додана в систему. Немає потреби додавати її ще раз.`,
    ru: `Эта карта уже добавлена. Нет необходимости добавлять ее еще раз.`,
    eng: `This card is already added. No need to add it again.`,
  },
  ls_add_card_button_label: {
    uk: `Додати картку`,
    ru: `Добавить карту`,
    eng: `Add card`,
  },
  ls_common_swipe_delete_button_label: {
    uk: `Видалити`,
    ru: `Удалить`,
    eng: `Delete`,
  },
  ls_pay_from_card_another_bank_empty_message: {
    uk: `Немає карток інших банків.`,
    ru: `Нет карт других банков.`,
    eng: `No other bank cards added.`,
  },
  ls_payment_confirmation_3d_secure_title: {
    uk: `Може знадобитись додаткове підтвердження`,
    ru: `Может понадобиться дополнительное подтверждение`,
    eng: `Additional confirmation may be required`,
  },
  ls_payment_confirmation_3d_secure_message: {
    uk: `Для здійснення платежу може знадобитись підтвердження за технологією 3-D Secure або Lookup. Натисніть ПРОДОВЖИТИ для відправки платежу.`,
    ru: `Для осуществления платежа может понадобиться подтверждение по технологии 3-D Secure или Lookup. Нажмите ПРОДОЛЖИТЬ для отправки платежа.`,
    eng: `Additional confirmation with 3-D Secure or Lookup technology may be necessary. Press CONTINUE to send the payment.`,
  },
  ls_payment_confirmation_continue_button_normal: {
    uk: `Продовжити`,
    ru: `Продолжить`,
    eng: `Continue`,
  },
  ls_pay_to_card_widget_title: {
    uk: `Переказати на картку`,
    ru: `Перевести на карту`,
    eng: `Transfer to card`,
  },
  ls_pay_to_card_screen_title: {
    uk: `Переказати на картку`,
    ru: `Перевести на карту`,
    eng: `Transfer to card`,
  },
  ls_pay_to_card_selector_enter_number_label: {
    uk: `За номером`,
    ru: `По номеру`,
    eng: `By number`,
  },
  ls_pay_to_card_selector_added_cards_label: {
    uk: `Додані картки`,
    ru: `Добавленные карты`,
    eng: `Added cards`,
  },
  ls_deposit_schedule_empty_message: {
    uk: `Графік виплат відсутній`,
    ru: `График выплат отсутствует`,
    eng: `No payout schedule`,
  },
  ls_credit_schedule_empty_message: {
    uk: `Графік платежів відсутній`,
    ru: `График платежей отсутствует`,
    eng: `No payment schedule`,
  },
  ls_delete_card_dialog_title: {
    uk: `Видалити картку`,
    ru: `Удалить карту`,
    eng: `Delete card`,
  },
  ls_delete_card_dialog_message: {
    uk: `Ви дійсно бажаєте видалити цю картку?`,
    ru: `Вы действительно желаете удалить эту карту?`,
    eng: `Do you really want to delete this card?`,
  },
  ls_add_card_fail_title: {
    uk: `Не вдалося додати картку`,
    ru: `Не удалось добавить карту`,
    eng: `Unable to add card`,
  },
  ls_add_card_fail_message: {
    uk: `При додаванні картки виникла помилка. Будь ласка, спробуйте ще раз.`,
    ru: `При добавлении карты возникла ошибка. Пожалуйста, попробуйте еще раз.`,
    eng: `An error occurred while adding the card. Please try again.`,
  },
  ls_common_unable_to_load_options_message: {
    uk: `Не вдалось завантажити опції для вибору`,
    ru: `Не удалось загрузить опции для выбора`,
    eng: `Unable to load selection options`,
  },
  ls_payment_to_requisites_iban_field_label: {
    uk: `IBAN отримувача`,
    ru: `IBAN получателя`,
    eng: `Receiver's IBAN`,
  },
  ls_common_unknown_error_title: {
    uk: `Сталася помилка`,
    ru: `Возникла ошибка`,
    eng: `Problem occurred`,
  },
  ls_common_unknown_error_message: {
    uk: `Виникла непередбачена помилка`,
    ru: `Возникла непредвиденная ошибка`,
    eng: `An unforeseen problem has occurred`,
  },
  ls_common_additional_fee_may_apply_message: {
    uk: `Зверніть увагу! Може бути списана додаткова комісія згідно тарифів Вашої картки.`,
    ru: `Обратите внимание! Может быть списана дополнительная комиссия согласно тарифов Вашей карты.`,
    eng: `Attention! Additional fee may be applied in accordance to service conditions of your card.`,
  },
  ls_currency_widget_EUR_USD: {
    uk: `EUR/USD`,
    ru: `EUR/USD`,
    eng: `EUR/USD`,
  },
  ls_payment_confirmation_no_otp_message: {
    uk: `Натисніть кнопку Підтвердити, щоб здійснити операцію.`,
    ru: `Нажмите кнопку Подтвердить, чтобы совершить операцию.`,
    eng: `Click the Confirm button to execute the operation.`,
  },
  ls_payment_to_requisites_iban_field_placeholder: {
    uk: `Введіть 29 символів`,
    ru: `Введите 29 символов`,
    eng: `Enter 29 symbols`,
  },
  ls_bills_payment_search_widget_title: {
    uk: `Пошук послуги або постачальника`,
    ru: `Поиск услуги или поставщика`,
    eng: `Search for service or provider`,
  },
  ls_bills_payment_search_field_placeholder: {
    uk: `Щоб створити платіж введіть назву постачальника`,
    ru: `Чтобы создать платеж введите название поставщика`,
    eng: `To create a payment enter provider name`,
  },
  ls_bills_payment_search_button_normal: {
    uk: `Шукати`,
    ru: `Искать`,
    eng: `Search`,
  },
  ls_bills_payment_screen_title: {
    uk: `Каталог послуг та постачальників `,
    ru: `Каталог услуг и поставщиков`,
    eng: `Bills & Services catalogue`,
  },
  ls_bills_payment_category_search_field_placeholder: {
    uk: `Введіть назву щоб почати пошук`,
    ru: `Введите название, чтобы начать поиск`,
    eng: `Enter the name to begin search`,
  },
  ls_bills_payment_category_tickets_label: {
    uk: `Електронні квитки`,
    ru: `Электронные билеты`,
    eng: `Electronic tickets`,
  },
  ls_bills_payment_category_distribution_label: {
    uk: `Дистрибуція`,
    ru: `Дистрибуция`,
    eng: `Distribution`,
  },
  ls_bills_payment_category_internet_label: {
    uk: `Інтернет`,
    ru: `Интернет`,
    eng: `Internet`,
  },
  ls_bills_payment_category_cell_label: {
    uk: `Мобільний зв'язок`,
    ru: `Мобильная связь`,
    eng: `Mobile network`,
  },
  ls_bills_payment_category_games_label: {
    uk: `Онлайн ігри`,
    ru: `Онлайн игры`,
    eng: `Online game`,
  },
  ls_bills_payment_category_security_label: {
    uk: `Охорона`,
    ru: `Охрана`,
    eng: `Security`,
  },
  ls_bills_payment_category_insurance_label: {
    uk: `Страхування`,
    ru: `Страхование`,
    eng: `Insurance`,
  },
  ls_bills_payment_category_tv_label: {
    uk: `Телебачення`,
    ru: `Телевидение`,
    eng: `Television`,
  },
  ls_bills_payment_category_landline_label: {
    uk: `Телефонія`,
    ru: `Телефония`,
    eng: `Telephony`,
  },
  ls_bills_payment_region_filter_label: {
    uk: `Регіон: `,
    ru: `Регион: `,
    eng: `Region: `,
  },
  ls_bills_payment_select_region_screen_title: {
    uk: `Оберіть регіон`,
    ru: `Выберите регион`,
    eng: `Select region`,
  },
  ls_bills_payment_region_filter_option_all: {
    uk: `Всі регіони`,
    ru: `Все регионы`,
    eng: `All regions`,
  },
  ls_common_loading_text: {
    uk: `Завантаження…`,
    ru: `Загрузка…`,
    eng: `Loading…`,
  },
  ls_operation_type_bills_payment_payment: {
    uk: `Оплата послуг`,
    ru: `Оплата услуг`,
    eng: `Bills & Services`,
  },
  ls_payment_parameters_widget_title: {
    uk: `Параметри платежу`,
    ru: `Параметры платежа`,
    eng: `Payment parameters`,
  },
  ls_common_filed_placeholder: {
    uk: `Введіть значення`,
    ru: `Введите значение`,
    eng: `Enter value`,
  },
  ls_common_empty_filed_error_message: {
    uk: `Введіть значення`,
    ru: `Введите значение`,
    eng: `Enter value`,
  },
  ls_bills_payment_next_button_normal: {
    uk: `Сплатити`,
    ru: `Оплатить`,
    eng: `Pay`,
  },
  ls_bills_payment_payment_next_button_loading: {
    uk: `З\’єднання`,
    ru: `Соединение`,
    eng: `Connecting`,
  },
  ls_bills_payment_error_payment_failed_title: {
    uk: `Помилка оплати`,
    ru: `Ошибка оплаты`,
    eng: `Payment failed`,
  },
  ls_bills_payment_no_services_message: {
    uk: `Немає послуг доступних для оплати. `,
    ru: `Нет услуг доступных для оплаты.`,
    eng: `No services available for payment.`,
  },
  ls_bills_payment_search_nothing_found_message: {
    uk: `Нічого не знайдено. Спробуйте спростити пошуковий запит.`,
    ru: `Ничего не найдено. Попробуйте упростить поисковый запрос.`,
    eng: `Nothing found. Try to simplify your search request.`,
  },
  ls_bills_payment_error_payment_impossible_title: {
    uk: `Оплата неможлива`,
    ru: `Оплата невозможна`,
    eng: `Payment impossible`,
  },
  ls_bills_payment_error_payment_failed_text: {
    uk: `Неможливо провести операцію. Перевірте введені дані та спробуйте ще раз.`,
    ru: `Невозможно провести операцию. Проверьте введенные данные и попробуйте еще раз.`,
    eng: `Unable to perform payment. Check your entries and try again.`,
  },
  ls_payment_error_check_amount_title: {
    uk: `Перевірте суму платежу`,
    ru: `Проверьте сумму платежа`,
    eng: `Check amount`,
  },
  ls_payment_error_check_amount_from_message: {
    uk: `Має бути в межах від `,
    ru: `Должна быть в пределах от `,
    eng: `Should be from `,
  },
  ls_payment_error_check_amount_to_message: {
    uk: ` до `,
    ru: ` до `,
    eng: ` to `,
  },
  ls_bills_payment_failed_to_load_catalogue_error: {
    uk: `Не вдалось завантажити каталог постачальників та послуг. Спробуйте ще раз через деякий час.`,
    ru: `Не удалось загрузить каталог поставщиков и услуг. Попробуйте еще раз через некоторое время.`,
    eng: `Unable to load the catalogue of providers and services. Please, try again later.`,
  },
  ls_account_to_card_from_title: {
    uk: `Переказ на картку Полтава-банк`,
    ru: `Перевод на карту Полтава-банк`,
    eng: `Transfer to Poltava-bank card`,
  },
  ls_rename_card_dialog_title: {
    uk: `Змінити назву`,
    ru: `Сменить название`,
    eng: `Change name`,
  },
  ls_new_deposit_initial_amount_label: {
    uk: `Початкова сума`,
    ru: `Начальная сумма`,
    eng: `Initial amount`,
  },
  ls_signup_number_not_financial_or_not_connected_to_card_error_title: {
    uk: `Недійсний номер`,
    ru: `Недействительный номер`,
    eng: `Invalid number`,
  },
  ls_signup_number_not_financial_or_not_connected_to_card_error_message: {
    uk: `Номер телефону не є фінансовим або не прив\'язаний до введеного номеру пластикової картки. Зверніться в банк для уточнення даних (при собі мати паспорт та код платника податків).`,
    ru: `Номер телефона не является финансовым или не привязан к введенному номеру пластиковой карты. Обратитесь в банк для уточнения данных (при себе иметь паспорт и код налогоплательщика).`,
    eng: `Phone number is not a financial number or it is not connected to the entered payment card number. Contact the bank to update the data (bring passport and taxation number with you).`,
  },
  ls_signup_card_not_financial_or_not_connected_to_phone_error_message: {
    uk: `Номер телефону не є фінансовим або не прив\'язаний до введеного номеру пластикової картки. Зверніться в банк для уточнення даних (при собі мати паспорт та код платника податків).`,
    ru: `Номер телефона не является финансовым или не привязан к введенному номеру пластиковой карты. Обратитесь в банк для уточнения данных (при себе иметь паспорт и код налогоплательщика).`,
    eng: `Phone number is not a financial number or it is not connected to the entered payment card number. Contact the bank to update the data (bring passport and taxation number with you).`,
  },
  ls_payment_to_card_button_label: {
    uk: `Переказ на картку`,
    ru: `Перевод на карту`,
    eng: `Transfer to card`,
  },
  ls_transfer_to_card_screen_title: {
    uk: `Переказ на картку`,
    ru: `Перевод на карту`,
    eng: `Transfer to card`,
  },
  ls_deposit_categories_screen_title: {
    uk: `Категорії депозитів`,
    ru: `Категории депозитов`,
    eng: `Deposit categories`,
  },
  ls_deposit_products_unavailable_message: {
    uk: `Немає доступних депозитних програм.`,
    ru: `Нет доступных депозитных программ.`,
    eng: `No deposit programs available.`,
  },
  ls_repay_credit_terms_info_message: {
    uk: `Погашення заборгованості (в тому числі дострокове) не звільняє клієнта від сплати відсотків за користування кредитом за відповідний період.`,
    ru: `Погашение задолженности (в том числе досрочное) не освобождает клиента от уплаты процентов за пользование кредитом за соответствующий период.`,
    eng: `Debt repayment (including early repayment) does not exempt the client from paying interest on the loan for the relevant period.`,
  },
  ls_deposit_schedule_interest_before_taxation_label: {
    uk: `Нараховані відсотки до оподаткування`,
    ru: `Начисленные проценты до налогообложения`,
    eng: `Interest accrued before taxation`,
  },
  ls_common_session_is_expiring_in_message: {
    uk: `Ми помітили, що ви не користуєтесь додатком зараз. Сесію буде автоматично завершено за `,
    ru: `Мы заметили, что вы не пользуетесь приложением сейчас. Сессия автоматически завершится через `,
    eng: `We noticed that you are not using the application. The session will be automatically finished in `,
  },
  ls_common_session_is_expiring_continue_message: {
    uk: `Бажаєте продовжити її?`,
    ru: `Желаете продолжить ее?`,
    eng: `Do you want to continue it?`,
  },
  ls_common_session_is_expired_title: {
    ru: 'Время сессии истекло',
    uk: 'Час сесії вичерпано',
    eng: 'Session expired',
  },
  ls_common_session_is_expired_message: {
    ru: 'Сессия была автоматически завершена в связи с длительным отсутствием активности в приложении.',
    uk: "Сесію було автоматично завершено в зв'язку з тривалою відсутністю активності в додатку.",
    eng: 'The session was automatically finished due to lack of activity in the application.',
  },
  ls_signup_data_security_url_address: {
    uk: `https://poltavabank.com/polityka-informaczijnoyi-bezpeky/`,
    ru: `https://poltavabank.com/polityka-informaczijnoyi-bezpeky/`,
    eng: `https://poltavabank.com/polityka-informaczijnoyi-bezpeky/`,
  },
  ls_document_loading_dialog_title: {
    uk: `Документ завантажується`,
    ru: `Документ загружается`,
    eng: `Downloading document`,
  },
  ls_document_loading_dialog_message: {
    uk: `Ви зможете переглянути документ по завершенню завантаження.`,
    ru: `Вы сможете просмотреть документ по завершении загрузки.`,
    eng: `You will be able to view the document after the download is complete.`,
  },
  ls_document_failed_to_load_dialog_title: {
    uk: `Не вдалось завантажити`,
    ru: `Не удалось загрузить`,
    eng: `Failed to download`,
  },
  ls_document_failed_to_load_dialog_message: {
    uk: `Не вдалось завантажити документ. Будь ласка, спробуйте ще раз.`,
    ru: `Не удалось загрузить документ. Пожалуйста, попробуйте еще раз.`,
    eng: `Failed to capture the document. Please, try again.`,
  },
  ls_statement_select_period_title: {
    uk: `Виписка про рух коштів`,
    ru: `Выписка о движении средств`,
    eng: `Cash flow statement`,
  },
  ls_statement_select_period_message: {
    uk: `Оберіть період для формування виписки про рух коштів.`,
    ru: `Выберите период для формирования выписки о движении средств.`,
    eng: `Choose period to generate the cash flow excerpt.`,
  },
  ls_contract_in_pdf_action_label: {
    uk: `Договір в PDF`,
    ru: `Договор в PDF`,
    eng: `Contract in PDF`,
  },
  ls_pdf_document_file_name: {
    uk: `Документ`,
    ru: `Документ`,
    eng: `Document`,
  },
  ls_statement_start_of_period_field_label: {
    uk: `Початок періоду`,
    ru: `Начало периода`,
    eng: `Start of period`,
  },
  ls_statement_end_of_period_field_label: {
    uk: `Кінець періоду`,
    ru: `Конец периода`,
    eng: `End of period`,
  },
  ls_common_download_button_label: {
    uk: `Завантажити`,
    ru: `Загрузить`,
    eng: `Download`,
  },
  ls_login_account_blocked_error_title: {
    uk: `Доступ до системи заблоковано`,
    ru: `Доступ к системе заблокирован`,
    eng: `System is locked`,
  },
  ls_login_account_blocked_error_message_start: {
    uk: `Доступ заблоковано в цілях безпеки. Щоб розблокувати систему зверніться до Банку за номером `,
    ru: `Доступ заблокирован в целях безопасности. Чтобы разблокировать систему, обратитесь в Банк по номеру `,
    eng: `Access is blocked for security reasons. To unlock the system, contact the Bank at phone number `,
  },
  ls_login_account_blocked_error_message_phone: {
    uk: `0 800 407 009 `,
    ru: `0 800 407 009 `,
    eng: `0 800 407 009 `,
  },
  ls_login_account_blocked_error_message_end: {
    uk: `або натисніть кнопку СКИНУТИ ПАРОЛЬ для відновлення доступу до облікового запису.`,
    ru: `или нажмите кнопку СБРОСИТЬ ПАРОЛЬ для восстановления доступа к учетной записи.`,
    eng: `or click the RESET PASSWORD button to regain access to the account.`,
  },
  ls_login_account_blocked_reset_password_label: {
    uk: `Скинути пароль`,
    ru: `Сбросить пароль`,
    eng: `Reset password`,
  },
  ls_login_account_blocked_call_the_bank_label: {
    uk: `Зателефонувати в Банк`,
    ru: `Позвонить в Банк`,
    eng: `Call the Bank`,
  },
  ls_login_account_blocked_call_the_bank_phone_number: {
    uk: `0 800 407 009`,
    ru: `0 800 407 009`,
    eng: `0 800 407 009`,
  },
  ls_utility_service_bill_payment_parameters_screen_title: {
    uk: `Параметри оплати`,
    ru: `Параметры оплаты`,
    eng: `Payment parameters`,
  },
  ls_utility_service_bill_payment_parameters_block_title: {
    uk: `Параметри оплати`,
    ru: `Параметры оплаты`,
    eng: `Payment parameters`,
  },
  ls_utility_services_provider_field_label: {
    uk: `Постачальник`,
    ru: `Поставщик`,
    eng: `Provider`,
  },
  ls_utility_services_provider_enter_parameters_widget_title: {
    uk: `Введіть необхідні реквізити, щоб розпочати оплату.`,
    ru: `Введите необходимые реквизиты, чтобы начать оплату.`,
    eng: `Enter necessary requisites to begin the payment.`,
  },
  ls_utility_services_continue_button_normal: {
    uk: `Продовжити`,
    ru: `Продолжить`,
    eng: `Continue`,
  },
  ls_utility_service_bill_payment_details_screen_title: {
    uk: `Деталі оплати`,
    ru: `Детали оплаты`,
    eng: `Payment details`,
  },
  ls_utility_service_bill_amount_to_pay_label: {
    uk: `Сума до сплати`,
    ru: `Сумма к оплате`,
    eng: `Amount to pay`,
  },
  ls_utility_services_unable_to_pay_bill_error_title: {
    uk: `Оплата неможлива`,
    ru: `Оплата невозможна`,
    eng: `Payment failed`,
  },
  ls_utility_services_bill_unavailable_error_message: {
    uk: `Рахунок для сплати ще недоступний. Будь ласка, спробуйте провести оплату пізніше.`,
    ru: `Счет для оплаты еще недоступен. Пожалуйста, попробуйте провести оплату позже.`,
    eng: `Bill is not yet available. Please, try to perform the payment later.`,
  },
  ls_utility_services_unable_to_pay_bill_error_message: {
    uk: `Неможливо провести операцію. Перевірте введені дані та спробуйте ще раз.`,
    ru: `Не удалось провести операцию. Проверьте введенные данные и попробуйте еще раз.`,
    eng: `Unable to perform operation. Check your entries and try again.`,
  },
  ls_utility_services_insufficient_funds_error_message: {
    uk: `Недостатньо коштів на обраному рахунку.`,
    ru: `Недостаточно средств на выбранном счете.`,
    eng: `Not enough funds on selected account.`,
  },
  ls_card_settings_travel_info_url_label: {
    uk: `Докладніше про користування карткою за кордоном`,
    ru: `Подробнее об использовании карты за границей`,
    eng: `Learn more about using the card abroad`,
  },
  ls_card_settings_travel_info_url: {
    uk: `https://poltavabank.com/rozrahunok-chy-znyattya-koshtiv-za-kordonom/`,
    ru: `https://poltavabank.com/rozrahunok-chy-znyattya-koshtiv-za-kordonom/`,
    eng: `https://poltavabank.com/rozrahunok-chy-znyattya-koshtiv-za-kordonom/`,
  },
  ls_trip_abroad_widget_empty_title: {
    uk: `Немає активних виїздів за кордон.`,
    ru: `Нет активных выездов за границу.`,
    eng: `No active trips abroad.`,
  },
  ls_card_settings_travel_abroad_new_screen_title: {
    uk: `Виїзд за кордон`,
    ru: `Выезд за границу`,
    eng: `Trip abroad`,
  },
  ls_trip_abroad_countries_list_and_more_text: {
    uk: ` та ще `,
    ru: ` и еще `,
    eng: ` and more `,
  },
  ls_web_payments_option_label: {
    uk: `Розрахунки карткою в Інтернет`,
    ru: `Расчеты картой в Интернет`,
    eng: `Online payments with card`,
  },
  ls_web_payments_option_allow_label: {
    uk: `Дозволити:`,
    ru: `Разрешить:`,
    eng: `Allow: `,
  },
  ls_card_settings_web_payment_allowed_title: {
    uk: `Оплата в Інтернет дозволена!`,
    ru: `Оплата в Интернет разрешена!`,
    eng: `Online payments allowed!`,
  },
  ls_card_settings_web_payment_allowed_forbid_prompt: {
    uk: `Оплата в інтернет-магазинах дозволена для цієї картки. Бажаєте заборонити оплату в Інтернет?`,
    ru: `Оплата в интернет-магазинах разрешена для этой карты. Хотите запретить оплату в Интернет?`,
    eng: `Online payments with this card are allowed. Would you like to forbid them?`,
  },
  ls_card_settings_web_payment_forbidden_title: {
    uk: `Оплата в Інтернет заборонена!`,
    ru: `Оплата в Интернете запрещена!`,
    eng: `Online payments forbidden!`,
  },
  ls_card_settings_web_payment_forbidden_message: {
    uk: `Оплата в інтернет-магазинах заборонена.`,
    ru: `Оплата в интернет магазинах запрещена.`,
    eng: `Payments in online stores are forbidden.`,
  },
  ls_card_settings_web_payment_forbidden_allow_prompt: {
    uk: `Оплата в інтернет-магазинах заборонена для цієї картки. Бажаєте дозволити оплату в Інтернет?`,
    ru: `Оплата в интернет-магазинах запрещена для этой карты. Хотите разрешить оплату в Интернет?`,
    eng: `Online payments with this card are forbidden. Would you like to allow them?`,
  },
  ls_card_settings_web_payment_allowed_message: {
    uk: `Оплата в інтернет-магазинах дозволена.`,
    ru: `Оплата в интернет-магазинах разрешена.`,
    eng: `Payments in online stores are allowed.`,
  },
  ls_common_allow_button_label: {
    uk: `Дозволити`,
    ru: `Разрешить`,
    eng: `Allow`,
  },
  ls_common_forbid_button_label: {
    uk: `Заборонити`,
    ru: `Запретить`,
    eng: `Forbid`,
  },
  ls_receipt_button_label: {
    uk: `Квитанція`,
    ru: `Квитанция`,
    eng: `Receipt`,
  },
  ls_otp_confirmation_confirm_new_device_message: {
    uk: `Підтвердіть вхід в додаток на новому пристрої.`,
    ru: `Подтвердите вход в приложение на новом устройстве.`,
    eng: `Confirm sign in to app on a new device.`,
  },
  ls_message_details_operation_status_label: {
    uk: `Статус: `,
    ru: `Статус: `,
    eng: `Status: `,
  },
  ls_message_details_operation_status_rejected_text: {
    uk: `Відхилено`,
    ru: `Отклонено`,
    eng: `Status`,
  },
  ls_message_details_operation_status_completed_text: {
    uk: `Виконано`,
    ru: `Проведено`,
    eng: `Rejected`,
  },
  ls_message_details_card_number_label: {
    uk: `Платіжна картка: `,
    ru: `Платежная карта: `,
    eng: `Payment card: `,
  },
  ls_operation_details_transfer_type_label: {
    uk: `Тип переказу:`,
    ru: `Тип перевода: `,
    eng: `Transfer type:`,
  },
  ls_operation_details_uetr_label: {
    uk: `UETR:`,
    ru: `UETR:`,
    eng: `UETR:`,
  },
  ls_operation_details_rejected_reason_label: {
    uk: `Причина відхилення:`,
    ru: `Причина отказа:`,
    eng: `Reason for rejection:`,
  },
  ls_common_copied_to_buffer_message: {
    uk: `Скопійовано в буфер обміну`,
    ru: `Скопировано в буфер обмена`,
    eng: `Copied to clipboard`,
  },
};
